


// // import React, { useEffect, useState, useMemo } from "react";
// // import {
// //     BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
// //     ResponsiveContainer, PieChart, Pie, Cell, LineChart, Line,
// //     ComposedChart, Area, AreaChart, RadialBarChart, RadialBar
// // } from "recharts";
// // import {
// //     TrendingUp, TrendingDown, DollarSign, ShoppingBag, Package,
// //     Users, CreditCard, CheckCircle, Calculator,
// //     Building, Tag, Truck, FileText, Utensils, Coffee, Pizza,
// //     Cake, ShoppingCart, Calendar as CalendarIcon, Target,
// //     BarChart as BarChartIcon, PieChart as PieChartIcon,
// //     LineChart as LineChartIcon, AlertCircle, Shield,
// //     Activity, Scale, Wallet, ChevronDown, X, Menu,
// //     Download, Filter, Sparkles, Crown, Trophy, Zap, TrendingUp as TrendUp,
// //     RotateCcw, Star, Clock, PackageOpen, UserCheck,
// //     MessageSquare, ThumbsUp, Award, BarChart2, CreditCard as CreditCardIcon,
// //     Star as StarIcon, BarChart3, PieChart as PieChartIcon2, LineChart as LineChartIcon2,
// //     Percent, DollarSign as DollarSignIcon, CheckSquare
// // } from 'lucide-react';
// // import axios from "axios";
// // import * as XLSX from 'xlsx';

// // const FoodDashboard = () => {
// //     const [vendorId, setVendorId] = useState(null);
// //     const [loading, setLoading] = useState(true);
// //     const [data, setData] = useState(null);
// //     const [timeRange, setTimeRange] = useState('monthly');
// //     const [showMobileMenu, setShowMobileMenu] = useState(false);
// //     const [activeView, setActiveView] = useState('revenue');
// //     const [resetting, setResetting] = useState(false);
// //     const [isMobile, setIsMobile] = useState(false);

// //     // Enhanced color palette
// //     const colors = {
// //         primary: '#7c3aed', // Purple
// //         secondary: '#10b981', // Emerald
// //         accent: '#f59e0b', // Amber
// //         danger: '#ef4444', // Red
// //         info: '#3b82f6', // Blue
// //         success: '#10b981', // Green
// //         warning: '#f59e0b', // Yellow
// //         dark: '#1f2937',
// //         light: '#f9fafb',
// //         gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
// //         gradient2: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
// //         gradient3: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
// //     };

// //     // Date range state
// //     const [showDatePicker, setShowDatePicker] = useState(false);
// //     const [startDate, setStartDate] = useState(() => {
// //         const date = new Date();
// //         date.setDate(date.getDate() - 30);
// //         return date.toISOString().split('T')[0];
// //     });
// //     const [endDate, setEndDate] = useState(() => {
// //         return new Date().toISOString().split('T')[0];
// //     });

// //     // Responsive check
// //     useEffect(() => {
// //         const checkMobile = () => setIsMobile(window.innerWidth < 768);
// //         checkMobile();
// //         window.addEventListener('resize', checkMobile);
// //         return () => window.removeEventListener('resize', checkMobile);
// //     }, []);

// //     // Get vendor ID
// //     useEffect(() => {
// //         const storedVendorId = localStorage.getItem("vendorId");
// //         if (storedVendorId) setVendorId(storedVendorId);
// //     }, []);

// //     // Fetch data
// //     const fetchData = async () => {
// //         if (!vendorId) return;
// //         setResetting(true);
// //         try {
// //             const token = localStorage.getItem("authToken");
// //             if (!token) {
// //                 setLoading(false);
// //                 setResetting(false);
// //                 return;
// //             }
// //             const res = await axios.get(
// //                 `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/orders/statistics/dashboard/${vendorId}`,
// //                 { headers: { Authorization: `Bearer ${token}` } }
// //             );
// //             setData(res.data);
// //             setLoading(false);
// //         } catch (err) {
// //             console.error("Error fetching report:", err);
// //             setLoading(false);
// //         } finally {
// //             setResetting(false);
// //         }
// //     };

// //     // Reset function
// //     const handleReset = () => {
// //         setResetting(true);
// //         setTimeRange('monthly');
// //         const defaultStartDate = new Date();
// //         defaultStartDate.setDate(defaultStartDate.getDate() - 30);
// //         setStartDate(defaultStartDate.toISOString().split('T')[0]);
// //         setEndDate(new Date().toISOString().split('T')[0]);
// //         setActiveView('revenue');
// //         setShowDatePicker(false);
// //         if (isMobile) setShowMobileMenu(false);
// //         fetchData();
// //         setTimeout(() => setResetting(false), 1000);
// //     };

// //     useEffect(() => {
// //         fetchData();
// //     }, [vendorId]);

// //     // Handle date range change
// //     const handleDateRangeApply = () => {
// //         setTimeRange('custom');
// //         setShowDatePicker(false);
// //     };

// //     const handleDateRangeCancel = () => {
// //         setShowDatePicker(false);
// //     };

// //     // Calculate days difference
// //     const getDaysDifference = (start, end) => {
// //         const startDate = new Date(start);
// //         const endDate = new Date(end);
// //         const timeDiff = endDate.getTime() - startDate.getTime();
// //         return Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;
// //     };

// //     // Format date for display
// //     const formatDate = (dateString) => {
// //         const date = new Date(dateString);
// //         return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
// //     };

// //     // ========== DATA GENERATORS ==========

// //     // Generate date-wise revenue trend data
// //     const generateDateTrendData = useMemo(() => {
// //         if (timeRange === 'custom') {
// //             const daysDiff = getDaysDifference(startDate, endDate);
// //             const data = [];
// //             const start = new Date(startDate);

// //             for (let i = 0; i < daysDiff; i++) {
// //                 const currentDate = new Date(start);
// //                 currentDate.setDate(start.getDate() + i);
// //                 const revenue = 15000 + Math.random() * 10000;
// //                 const discount = Math.random() > 0.8 ? revenue * 0.1 : 0;
// //                 data.push({
// //                     date: currentDate.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }),
// //                     fullDate: currentDate,
// //                     revenue: Math.round(revenue),
// //                     netRevenue: Math.round(revenue - discount),
// //                     discount: Math.round(discount),
// //                     orders: Math.round(50 + Math.random() * 30)
// //                 });
// //             }
// //             return data;
// //         }

// //         const getDays = () => {
// //             switch (timeRange) {
// //                 case 'weekly': return 7;
// //                 case 'monthly': return 30;
// //                 case 'yearly': return 12;
// //                 default: return 30;
// //             }
// //         };

// //         const days = getDays();
// //         const data = [];

// //         for (let i = days - 1; i >= 0; i--) {
// //             const date = new Date();

// //             if (timeRange === 'weekly') {
// //                 date.setDate(date.getDate() - (i * 7));
// //                 const revenue = 100000 + Math.random() * 50000;
// //                 const discount = revenue * (0.05 + Math.random() * 0.05);
// //                 data.push({
// //                     date: `Week ${i + 1}`,
// //                     fullDate: new Date(date),
// //                     revenue: Math.round(revenue),
// //                     netRevenue: Math.round(revenue - discount),
// //                     discount: Math.round(discount),
// //                     orders: Math.round(200 + Math.random() * 100)
// //                 });
// //             } else if (timeRange === 'monthly') {
// //                 const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
// //                 const monthIndex = (11 - i) % 12;
// //                 const revenue = 350000 + Math.random() * 150000;
// //                 const discount = revenue * (0.08 + Math.random() * 0.07);
// //                 data.push({
// //                     date: months[monthIndex],
// //                     fullDate: new Date(date.getFullYear(), monthIndex, 1),
// //                     revenue: Math.round(revenue),
// //                     netRevenue: Math.round(revenue - discount),
// //                     discount: Math.round(discount),
// //                     orders: Math.round(1000 + Math.random() * 500)
// //                 });
// //             } else { // yearly
// //                 const years = ['2020', '2021', '2022', '2023', '2024'];
// //                 if (i < years.length) {
// //                     const revenue = 4000000 + Math.random() * 2000000;
// //                     const discount = revenue * (0.1 + Math.random() * 0.05);
// //                     data.push({
// //                         date: years[i],
// //                         fullDate: new Date(years[i]),
// //                         revenue: Math.round(revenue),
// //                         netRevenue: Math.round(revenue - discount),
// //                         discount: Math.round(discount),
// //                         orders: Math.round(12000 + Math.random() * 5000)
// //                     });
// //                 }
// //             }
// //         }
// //         return data;
// //     }, [timeRange, startDate, endDate]);

// //     // Generate expense trend data
// //     const generateExpenseTrendData = useMemo(() => {
// //         const dateData = generateDateTrendData;
// //         return dateData.map(item => {
// //             const expenses = {
// //                 COGS: Math.round(item.revenue * (0.35 + Math.random() * 0.05)),
// //                 Operating: Math.round(item.revenue * (0.20 + Math.random() * 0.03)),
// //                 Labor: Math.round(item.revenue * (0.18 + Math.random() * 0.02)),
// //                 Equipment: Math.round(item.revenue * (0.08 + Math.random() * 0.02)),
// //                 Marketing: Math.round(item.revenue * (0.06 + Math.random() * 0.01)),
// //                 Packaging: Math.round(item.revenue * (0.04 + Math.random() * 0.01)),
// //                 Delivery: Math.round(item.revenue * (0.12 + Math.random() * 0.03)),
// //                 Waste: Math.round(item.revenue * (0.03 + Math.random() * 0.01)),
// //                 Tax: Math.round(item.revenue * (0.05 + Math.random() * 0.01)),
// //                 Miscellaneous: Math.round(item.revenue * (0.02 + Math.random() * 0.01))
// //             };

// //             const totalExpenses = Object.values(expenses).reduce((a, b) => a + b, 0);
// //             const profit = item.netRevenue - totalExpenses;
// //             const profitMargin = (profit / item.revenue) * 100;
// //             const expenseRatio = (totalExpenses / item.revenue) * 100;

// //             return {
// //                 date: item.date,
// //                 fullDate: item.fullDate,
// //                 revenue: item.revenue,
// //                 netRevenue: item.netRevenue,
// //                 totalExpenses,
// //                 profit,
// //                 profitMargin: parseFloat(profitMargin.toFixed(1)),
// //                 expenseRatio: parseFloat(expenseRatio.toFixed(1)),
// //                 ...expenses
// //             };
// //         });
// //     }, [generateDateTrendData]);

// //     // Calculate totals for each time range
// //     const calculateTimeRangeTotals = useMemo(() => {
// //         const ranges = ['yearly', 'monthly', 'weekly', 'custom'];
// //         const totals = {};

// //         ranges.forEach(range => {
// //             let data;
// //             if (range === 'custom') {
// //                 const daysDiff = getDaysDifference(startDate, endDate);
// //                 const tempData = [];
// //                 const start = new Date(startDate);

// //                 for (let i = 0; i < daysDiff; i++) {
// //                     const currentDate = new Date(start);
// //                     currentDate.setDate(start.getDate() + i);
// //                     const revenue = 15000 + Math.random() * 10000;
// //                     const discount = Math.random() > 0.8 ? revenue * 0.1 : 0;
// //                     tempData.push({
// //                         revenue: Math.round(revenue),
// //                         netRevenue: Math.round(revenue - discount),
// //                         discount: Math.round(discount),
// //                         orders: Math.round(50 + Math.random() * 30)
// //                     });
// //                 }
// //                 data = tempData;
// //             } else {
// //                 const getDays = () => {
// //                     switch (range) {
// //                         case 'weekly': return 7;
// //                         case 'monthly': return 30;
// //                         case 'yearly': return 12;
// //                         default: return 30;
// //                     }
// //                 };

// //                 const days = getDays();
// //                 const tempData = [];

// //                 for (let i = days - 1; i >= 0; i--) {
// //                     if (range === 'weekly') {
// //                         const revenue = 100000 + Math.random() * 50000;
// //                         const discount = revenue * (0.05 + Math.random() * 0.05);
// //                         tempData.push({
// //                             revenue: Math.round(revenue),
// //                             netRevenue: Math.round(revenue - discount),
// //                             discount: Math.round(discount),
// //                             orders: Math.round(200 + Math.random() * 100)
// //                         });
// //                     } else if (range === 'monthly') {
// //                         const revenue = 350000 + Math.random() * 150000;
// //                         const discount = revenue * (0.08 + Math.random() * 0.07);
// //                         tempData.push({
// //                             revenue: Math.round(revenue),
// //                             netRevenue: Math.round(revenue - discount),
// //                             discount: Math.round(discount),
// //                             orders: Math.round(1000 + Math.random() * 500)
// //                         });
// //                     } else { // yearly
// //                         const revenue = 4000000 + Math.random() * 2000000;
// //                         const discount = revenue * (0.1 + Math.random() * 0.05);
// //                         tempData.push({
// //                             revenue: Math.round(revenue),
// //                             netRevenue: Math.round(revenue - discount),
// //                             discount: Math.round(discount),
// //                             orders: Math.round(12000 + Math.random() * 5000)
// //                         });
// //                     }
// //                 }
// //                 data = tempData;
// //             }

// //             // Calculate totals for this range
// //             const totalRevenue = data.reduce((sum, item) => sum + item.revenue, 0);
// //             const totalNetRevenue = data.reduce((sum, item) => sum + item.netRevenue, 0);
// //             const totalOrders = data.reduce((sum, item) => sum + item.orders, 0);

// //             // Calculate expenses
// //             const totalExpenses = Math.round(totalRevenue * 0.65); // Simplified expense calculation

// //             // For ratings (average based on orders)
// //             const totalReviews = Math.round(totalOrders * 0.3);
// //             const avgRating = 4.2 + Math.random() * 0.8;

// //             totals[range] = {
// //                 revenue: totalRevenue,
// //                 netRevenue: totalNetRevenue,
// //                 expenses: totalExpenses,
// //                 orders: totalOrders,
// //                 profit: totalNetRevenue - totalExpenses,
// //                 avgRating: parseFloat(avgRating.toFixed(1)),
// //                 totalReviews: totalReviews
// //             };
// //         });

// //         return totals;
// //     }, [timeRange, startDate, endDate]);

// //     // Generate revenue by order type
// //     const generateOrderTypeData = useMemo(() => {
// //         const types = [
// //             { name: 'Dine-in', description: 'In-restaurant dining', color: '#7c3aed', icon: <Utensils size={16} /> },
// //             { name: 'Takeaway', description: 'Pickup orders', color: '#10b981', icon: <ShoppingBag size={16} /> },
// //             { name: 'Delivery', description: 'Home delivery', color: '#3b82f6', icon: <ShoppingCart size={16} /> },
// //             { name: 'Table', description: 'Event catering', color: '#f59e0b', icon: <Users size={16} /> }
// //         ];

// //         const totalRevenue = generateDateTrendData.reduce((sum, item) => sum + item.revenue, 0);
// //         return types.map(type => {
// //             const percentage = type.name === 'Delivery' ? 40 :
// //                 type.name === 'Dine-in' ? 30 :
// //                     type.name === 'Takeaway' ? 15 : 5;
// //             const revenue = Math.round(totalRevenue * (percentage / 100));

// //             return {
// //                 ...type,
// //                 revenue,
// //                 percentage,
// //                 growth: (Math.random() > 0.5 ? 1 : -1) * (2 + Math.random() * 6)
// //             };
// //         });
// //     }, [generateDateTrendData]);

// //     // Generate revenue by category
// //     const generateCategoryData = useMemo(() => {
// //         const categories = [
// //             { name: 'Starters', description: 'Appetizers & snacks', color: '#f59e0b', icon: <Pizza size={16} /> },
// //             { name: 'Main Course', description: 'Main dishes & curries', color: '#10b981', icon: <Utensils size={16} /> },
// //             { name: 'Biryani', description: 'Rice dishes', color: '#ef4444', icon: <Pizza size={16} /> },
// //             { name: 'Fast Food', description: 'Burgers, pizzas, etc.', color: '#8b5cf6', icon: <ShoppingBag size={16} /> },
// //             { name: 'Desserts', description: 'Sweets & desserts', color: '#ec4899', icon: <Cake size={16} /> },
// //             { name: 'Beverages', description: 'Drinks & beverages', color: '#3b82f6', icon: <Coffee size={16} /> }
// //         ];

// //         const totalRevenue = generateDateTrendData.reduce((sum, item) => sum + item.revenue, 0);
// //         return categories.map(category => {
// //             const percentage = category.name === 'Main Course' ? 35 :
// //                 category.name === 'Biryani' ? 25 :
// //                     category.name === 'Starters' ? 15 :
// //                         category.name === 'Fast Food' ? 10 :
// //                             category.name === 'Beverages' ? 8 : 7;
// //             const revenue = Math.round(totalRevenue * (percentage / 100));

// //             return {
// //                 ...category,
// //                 revenue,
// //                 percentage,
// //                 growth: (Math.random() > 0.5 ? 1 : -1) * (3 + Math.random() * 8)
// //             };
// //         }).sort((a, b) => b.revenue - a.revenue);
// //     }, [generateDateTrendData]);

// //     // Add this component after CategoryPerformance component
// //     const ItemPerformanceHighlights = () => {
// //         const topItemsData = generateTopItemsData;

// //         // Sort items by revenue to get top performers
// //         const sortedItems = [...topItemsData].sort((a, b) => b.revenue - a.revenue);
// //         const topPerformer = sortedItems[0];
// //         const worstPerformer = sortedItems[sortedItems.length - 1];

// //         // Find highest and lowest profit margin items
// //         const sortedByMargin = [...topItemsData].sort((a, b) => b.profitMargin - a.profitMargin);
// //         const highestMargin = sortedByMargin[0];
// //         const lowestMargin = sortedByMargin[sortedByMargin.length - 1];

// //         // Find most and least ordered items
// //         const sortedByOrders = [...topItemsData].sort((a, b) => b.orders - a.orders);
// //         const mostOrdered = sortedByOrders[0];
// //         const leastOrdered = sortedByOrders[sortedByOrders.length - 1];

// //         // Calculate averages for comparison
// //         const avgRevenue = topItemsData.reduce((sum, item) => sum + item.revenue, 0) / topItemsData.length;
// //         const avgProfitMargin = topItemsData.reduce((sum, item) => sum + item.profitMargin, 0) / topItemsData.length;
// //         const avgOrders = topItemsData.reduce((sum, item) => sum + item.orders, 0) / topItemsData.length;

// //         return (
// //             <div style={{
// //                 background: 'white',
// //                 borderRadius: '24px',
// //                 padding: isMobile ? '20px' : '28px',
// //                 marginBottom: isMobile ? '20px' : '28px',
// //                 border: '1px solid #e2e8f0',
// //                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //                 position: 'relative',
// //                 overflow: 'hidden'
// //             }}>
// //                 <div style={{
// //                     position: 'absolute',
// //                     top: 0,
// //                     left: 0,
// //                     right: 0,
// //                     height: '4px',
// //                     background: 'linear-gradient(90deg, #10b981, #ef4444)'
// //                 }}></div>

// //                 <div style={{ marginBottom: '28px' }}>
// //                     <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
// //                         <div style={{
// //                             width: '48px',
// //                             height: '48px',
// //                             borderRadius: '12px',
// //                             background: 'linear-gradient(135deg, #10b981 0%, #ef4444 100%)',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             justifyContent: 'center',
// //                             color: 'white'
// //                         }}>
// //                             <Trophy size={24} />
// //                         </div>
// //                         <div>
// //                             <h3 style={{ 
// //                                 fontSize: isMobile ? '18px' : '22px', 
// //                                 fontWeight: '800', 
// //                                 color: '#1e293b', 
// //                                 marginBottom: '2px' 
// //                             }}>
// //                                 Item Performance Highlights
// //                             </h3>
// //                             <p style={{ 
// //                                 fontSize: isMobile ? '13px' : '15px', 
// //                                 color: '#64748b',
// //                                 lineHeight: 1.3
// //                             }}>
// //                                 Top performer and items needing attention with detailed metrics
// //                             </p>
// //                         </div>
// //                     </div>
// //                 </div>

// //                 {/* Performance Leaders Section - 2x2 Grid on desktop, stacked on mobile */}
// //                 <div style={{
// //                     display: 'grid',
// //                     gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
// //                     gap: isMobile ? '20px' : '24px',
// //                     marginBottom: '32px'
// //                 }}>
// //                     {/* Top Performer - Highest Revenue */}
// //                     <div style={{
// //                         background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(16, 185, 129, 0.05) 100%)',
// //                         borderRadius: '20px',
// //                         padding: '24px',
// //                         border: '2px solid rgba(16, 185, 129, 0.2)',
// //                         position: 'relative',
// //                         overflow: 'hidden'
// //                     }}>
// //                         <div style={{
// //                             position: 'absolute',
// //                             top: '12px',
// //                             right: '12px',
// //                             background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
// //                             color: 'white',
// //                             padding: '6px 16px',
// //                             borderRadius: '20px',
// //                             fontSize: '12px',
// //                             fontWeight: '700',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             gap: '6px',
// //                             boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
// //                             letterSpacing: '0.5px'
// //                         }}>
// //                             <Crown size={14} />
// //                             TOP REVENUE
// //                         </div>

// //                         <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px', marginTop: '10px' }}>
// //                             <div style={{
// //                                 width: '64px',
// //                                 height: '64px',
// //                                 borderRadius: '16px',
// //                                 background: '#10b981',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 justifyContent: 'center',
// //                                 color: 'white',
// //                                 flexShrink: 0,
// //                                 boxShadow: '0 8px 24px rgba(16, 185, 129, 0.4)',
// //                                 fontSize: '24px',
// //                                 fontWeight: '800'
// //                             }}>
// //                                 #1
// //                             </div>
// //                             <div style={{ flex: 1 }}>
// //                                 <h4 style={{ 
// //                                     fontSize: '22px', 
// //                                     fontWeight: '800', 
// //                                     color: '#1e293b', 
// //                                     marginBottom: '4px' 
// //                                 }}>
// //                                     {topPerformer.name}
// //                                 </h4>
// //                                 <div style={{
// //                                     padding: '4px 12px',
// //                                     background: '#dcfce7',
// //                                     color: '#10b981',
// //                                     borderRadius: '12px',
// //                                     fontSize: '12px',
// //                                     fontWeight: '700',
// //                                     display: 'inline-block',
// //                                     border: '1px solid #bbf7d0'
// //                                 }}>
// //                                     {topPerformer.category}
// //                                 </div>
// //                             </div>
// //                         </div>

// //                         <div style={{
// //                             display: 'grid',
// //                             gridTemplateColumns: 'repeat(2, 1fr)',
// //                             gap: '16px',
// //                             marginTop: '20px'
// //                         }}>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Revenue</p>
// //                                 <p style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b' }}>
// //                                     ₹{(topPerformer.revenue / 1000).toFixed(0)}K
// //                                 </p>
// //                                 <p style={{ fontSize: '11px', color: topPerformer.revenue > avgRevenue ? '#10b981' : '#ef4444' }}>
// //                                     {topPerformer.revenue > avgRevenue ? '+' : ''}
// //                                     {((topPerformer.revenue / avgRevenue - 1) * 100).toFixed(0)}% above avg
// //                                 </p>
// //                             </div>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Orders</p>
// //                                 <p style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b' }}>
// //                                     {topPerformer.orders.toLocaleString()}
// //                                 </p>
// //                                 <p style={{ fontSize: '11px', color: topPerformer.orders > avgOrders ? '#10b981' : '#ef4444' }}>
// //                                     {topPerformer.orders > avgOrders ? '+' : ''}
// //                                     {((topPerformer.orders / avgOrders - 1) * 100).toFixed(0)}% above avg
// //                                 </p>
// //                             </div>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Profit Margin</p>
// //                                 <p style={{ fontSize: '20px', fontWeight: '800', color: colors.success }}>
// //                                     {topPerformer.profitMargin}%
// //                                 </p>
// //                             </div>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Market Share</p>
// //                                 <p style={{ fontSize: '20px', fontWeight: '800', color: '#7c3aed' }}>
// //                                     {topPerformer.percentage}%
// //                                 </p>
// //                             </div>
// //                         </div>
// //                     </div>

// //                     {/* Needs Attention - Lowest Revenue */}
// //                     <div style={{
// //                         background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(239, 68, 68, 0.05) 100%)',
// //                         borderRadius: '20px',
// //                         padding: '24px',
// //                         border: '2px solid rgba(239, 68, 68, 0.2)',
// //                         position: 'relative',
// //                         overflow: 'hidden'
// //                     }}>
// //                         <div style={{
// //                             position: 'absolute',
// //                             top: '12px',
// //                             right: '12px',
// //                             background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
// //                             color: 'white',
// //                             padding: '6px 16px',
// //                             borderRadius: '20px',
// //                             fontSize: '12px',
// //                             fontWeight: '700',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             gap: '6px',
// //                             boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
// //                             letterSpacing: '0.5px'
// //                         }}>
// //                             <AlertCircle size={14} />
// //                             LOW REVENUE
// //                         </div>

// //                         <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px', marginTop: '10px' }}>
// //                             <div style={{
// //                                 width: '64px',
// //                                 height: '64px',
// //                                 borderRadius: '16px',
// //                                 background: '#ef4444',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 justifyContent: 'center',
// //                                 color: 'white',
// //                                 flexShrink: 0,
// //                                 boxShadow: '0 8px 24px rgba(239, 68, 68, 0.4)',
// //                                 fontSize: '24px',
// //                                 fontWeight: '800'
// //                             }}>
// //                                 #{sortedItems.length}
// //                             </div>
// //                             <div style={{ flex: 1 }}>
// //                                 <h4 style={{ 
// //                                     fontSize: '22px', 
// //                                     fontWeight: '800', 
// //                                     color: '#1e293b', 
// //                                     marginBottom: '4px' 
// //                                 }}>
// //                                     {worstPerformer.name}
// //                                 </h4>
// //                                 <div style={{
// //                                     padding: '4px 12px',
// //                                     background: '#fee2e2',
// //                                     color: '#ef4444',
// //                                     borderRadius: '12px',
// //                                     fontSize: '12px',
// //                                     fontWeight: '700',
// //                                     display: 'inline-block',
// //                                     border: '1px solid #fecaca'
// //                                 }}>
// //                                     {worstPerformer.category}
// //                                 </div>
// //                             </div>
// //                         </div>

// //                         <div style={{
// //                             display: 'grid',
// //                             gridTemplateColumns: 'repeat(2, 1fr)',
// //                             gap: '16px',
// //                             marginTop: '20px'
// //                         }}>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Revenue</p>
// //                                 <p style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b' }}>
// //                                     ₹{(worstPerformer.revenue / 1000).toFixed(0)}K
// //                                 </p>
// //                                 <p style={{ fontSize: '11px', color: '#ef4444' }}>
// //                                     {((worstPerformer.revenue / avgRevenue - 1) * 100).toFixed(0)}% below avg
// //                                 </p>
// //                             </div>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Orders</p>
// //                                 <p style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b' }}>
// //                                     {worstPerformer.orders.toLocaleString()}
// //                                 </p>
// //                                 <p style={{ fontSize: '11px', color: '#ef4444' }}>
// //                                     {((worstPerformer.orders / avgOrders - 1) * 100).toFixed(0)}% below avg
// //                                 </p>
// //                             </div>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Profit Margin</p>
// //                                 <p style={{ fontSize: '20px', fontWeight: '800', color: colors.danger }}>
// //                                     {worstPerformer.profitMargin}%
// //                                 </p>
// //                             </div>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Recommendation</p>
// //                                 <div style={{
// //                                     padding: '6px 12px',
// //                                     background: '#fee2e2',
// //                                     color: '#ef4444',
// //                                     borderRadius: '12px',
// //                                     fontSize: '12px',
// //                                     fontWeight: '700',
// //                                     display: 'inline-block',
// //                                     border: '1px solid #fecaca'
// //                                 }}>
// //                                     🔍 Review Recipe/Pricing
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>



// //                 {/* Summary Stats Row */}

// //             </div>
// //         );
// //     };

// //     // Generate top selling items
// //     const generateTopItemsData = useMemo(() => {
// //         const items = [
// //             { name: 'Chicken Biryani', category: 'Biryani', price: 320, cost: 180 },
// //             { name: 'Paneer Butter Masala', category: 'Main Course', price: 280, cost: 120 },
// //             { name: 'Veg Spring Rolls', category: 'Starters', price: 180, cost: 80 },
// //             { name: 'Chocolate Pastry', category: 'Desserts', price: 120, cost: 40 },
// //             { name: 'Cold Coffee', category: 'Beverages', price: 100, cost: 30 },
// //             { name: 'Veg Pizza', category: 'Fast Food', price: 200, cost: 100 },
// //             { name: 'Chicken Curry', category: 'Main Course', price: 300, cost: 140 },
// //             { name: 'Gulab Jamun', category: 'Desserts', price: 80, cost: 20 },
// //             { name: 'Mango Shake', category: 'Beverages', price: 110, cost: 35 },
// //             { name: 'French Fries', category: 'Fast Food', price: 130, cost: 50 }
// //         ];

// //         const totalRevenue = generateDateTrendData.reduce((sum, item) => sum + item.revenue, 0);
// //         return items.map(item => {
// //             const percentage = 2 + Math.random() * 6;
// //             const revenue = Math.round(totalRevenue * (percentage / 100));
// //             const orders = Math.round(revenue / item.price);
// //             const profit = revenue - (orders * item.cost);
// //             const profitMargin = (profit / revenue) * 100;

// //             return {
// //                 ...item,
// //                 revenue,
// //                 orders,
// //                 profit,
// //                 profitMargin: parseFloat(profitMargin.toFixed(1)),
// //                 percentage: parseFloat(percentage.toFixed(1))
// //             };
// //         }).sort((a, b) => b.revenue - a.revenue);
// //     }, [generateDateTrendData]);

// //     // Generate payment data
// //     const generatePaymentData = useMemo(() => {
// //         const methods = [
// //             { name: 'Cash', description: 'Cash payments', color: '#10b981', icon: <DollarSign size={16} /> },
// //             { name: 'UPI', description: 'Digital payments', color: '#7c3aed', icon: <CreditCard size={16} /> },
// //             { name: 'Card', description: 'Credit/Debit cards', color: '#3b82f6', icon: <CreditCard size={16} /> },
// //             { name: 'Wallet', description: 'E-wallets', color: '#f59e0b', icon: <CreditCard size={16} /> },
// //             { name: 'Credit', description: 'Credit accounts', color: '#ef4444', icon: <CreditCard size={16} /> }
// //         ];

// //         const totalRevenue = generateDateTrendData.reduce((sum, item) => sum + item.revenue, 0);
// //         return methods.map(method => {
// //             const percentage = method.name === 'UPI' ? 45 :
// //                 method.name === 'Cash' ? 25 :
// //                     method.name === 'Card' ? 15 :
// //                         method.name === 'Wallet' ? 10 : 5;
// //             const amount = Math.round(totalRevenue * (percentage / 100));

// //             return {
// //                 ...method,
// //                 amount,
// //                 percentage,
// //                 transactions: Math.round(amount / (method.name === 'Cash' ? 500 : 800))
// //             };
// //         });
// //     }, [generateDateTrendData]);

// //     // Generate gross vs net revenue data
// //     const generateGrossNetData = useMemo(() => {
// //         return generateDateTrendData.map(item => ({
// //             date: item.date,
// //             gross: item.revenue,
// //             net: item.netRevenue,
// //             discount: item.discount,
// //             discountRate: parseFloat(((item.discount / item.revenue) * 100).toFixed(1))
// //         }));
// //     }, [generateDateTrendData]);

// //     // Generate discount impact data
// //     const generateDiscountImpactData = useMemo(() => {
// //         return generateDateTrendData.map((item, index) => ({
// //             date: item.date,
// //             ordersWithoutDiscount: Math.round(item.orders * 0.8),
// //             ordersWithDiscount: item.orders,
// //             discountOrders: Math.round(item.orders * 0.2),
// //             revenueWithoutDiscount: Math.round(item.revenue * 1.1),
// //             actualRevenue: item.revenue,
// //             discountAmount: item.discount,
// //             uplift: 25 + Math.random() * 15
// //         }));
// //     }, [generateDateTrendData]);

// //     // Generate expense data
// //     const generateExpenseData = useMemo(() => {
// //         const totalRevenue = generateDateTrendData.reduce((sum, item) => sum + item.revenue, 0);

// //         const expenses = [
// //             {
// //                 category: 'COGS',
// //                 description: 'Cost of Goods Sold',
// //                 details: 'Ingredients cost consumed',
// //                 purpose: 'Controls food margin',
// //                 color: '#ef4444',
// //                 icon: <Calculator size={16} />,
// //                 percentage: 35,
// //                 amount: Math.round(totalRevenue * 0.35)
// //             },
// //             {
// //                 category: 'Operating Expenses',
// //                 description: 'Fixed operational costs',
// //                 details: 'Rent, Electricity, Gas, Salaries, Licenses',
// //                 purpose: 'Tracks unavoidable costs',
// //                 color: '#f59e0b',
// //                 icon: <Building size={16} />,
// //                 percentage: 20,
// //                 amount: Math.round(totalRevenue * 0.20)
// //             },
// //             {
// //                 category: 'Labor Cost',
// //                 description: 'Staff salaries & benefits',
// //                 details: 'Payroll, overtime, incentives',
// //                 purpose: 'Improves workforce planning',
// //                 color: '#3b82f6',
// //                 icon: <Users size={16} />,
// //                 percentage: 18,
// //                 amount: Math.round(totalRevenue * 0.18)
// //             },
// //             {
// //                 category: 'Equipment Cost',
// //                 description: 'Kitchen & maintenance',
// //                 details: 'AMC, repairs, purchase',
// //                 purpose: 'Maintenance efficiency',
// //                 color: '#8b5cf6',
// //                 icon: <Package size={16} />,
// //                 percentage: 8,
// //                 amount: Math.round(totalRevenue * 0.08)
// //             },
// //             {
// //                 category: 'Marketing Expense',
// //                 description: 'Promotions & advertising',
// //                 details: 'Ads, offers, branding',
// //                 purpose: 'Return on marketing investment',
// //                 color: '#ec4899',
// //                 icon: <Tag size={16} />,
// //                 percentage: 6,
// //                 amount: Math.round(totalRevenue * 0.06)
// //             },
// //             {
// //                 category: 'Packaging Cost',
// //                 description: 'Delivery materials',
// //                 details: 'Delivery packaging & takeaway material',
// //                 purpose: 'Impacts order profitability',
// //                 color: '#10b981',
// //                 icon: <ShoppingBag size={16} />,
// //                 percentage: 4,
// //                 amount: Math.round(totalRevenue * 0.04)
// //             },
// //             {
// //                 category: 'Delivery Commission',
// //                 description: 'Platform fees',
// //                 details: 'Swiggy / Zomato / logistics fee',
// //                 purpose: 'Influences pricing decisions',
// //                 color: '#6366f1',
// //                 icon: <Truck size={16} />,
// //                 percentage: 12,
// //                 amount: Math.round(totalRevenue * 0.12)
// //             },
// //             {
// //                 category: 'Waste & Expiry',
// //                 description: 'Inventory losses',
// //                 details: 'Raw material wasted or expired',
// //                 purpose: 'Identify negligence / control inventory',
// //                 color: '#f97316',
// //                 icon: <AlertCircle size={16} />,
// //                 percentage: 3,
// //                 amount: Math.round(totalRevenue * 0.03)
// //             },
// //             {
// //                 category: 'Tax & Compliance',
// //                 description: 'Government fees',
// //                 details: 'GST filing, government fees',
// //                 purpose: 'Financial discipline',
// //                 color: '#14b8a6',
// //                 icon: <FileText size={16} />,
// //                 percentage: 5,
// //                 amount: Math.round(totalRevenue * 0.05)
// //             },
// //             {
// //                 category: 'Miscellaneous',
// //                 description: 'Other expenses',
// //                 details: 'Extra cost entries',
// //                 purpose: 'Track unknown leakage',
// //                 color: '#8b5cf6',
// //                 icon: <Shield size={16} />,
// //                 percentage: 2,
// //                 amount: Math.round(totalRevenue * 0.02)
// //             }
// //         ];

// //         const totalExpenses = expenses.reduce((sum, expense) => sum + expense.amount, 0);
// //         const netProfit = totalRevenue - totalExpenses;
// //         const profitMargin = (netProfit / totalRevenue) * 100;

// //         return {
// //             expenses,
// //             summary: {
// //                 totalRevenue,
// //                 totalExpenses,
// //                 netProfit,
// //                 profitMargin: parseFloat(profitMargin.toFixed(1)),
// //                 expenseToRevenue: parseFloat(((totalExpenses / totalRevenue) * 100).toFixed(1))
// //             }
// //         };
// //     }, [generateDateTrendData]);

// //     // ========== NEW DATA GENERATORS FOR ORDERS, PAYMENTS, RATINGS ==========

// //     // Generate orders analysis data
// //     const generateOrdersData = useMemo(() => {
// //         const dateData = generateDateTrendData;
// //         const totalOrders = dateData.reduce((sum, item) => sum + item.orders, 0);

// //         return {
// //             trend: dateData.map(item => ({
// //                 date: item.date,
// //                 orders: item.orders,
// //                 avgOrderValue: Math.round(item.revenue / item.orders),
// //                 peakHours: {
// //                     lunch: Math.round(item.orders * 0.4),
// //                     dinner: Math.round(item.orders * 0.5),
// //                     others: Math.round(item.orders * 0.1)
// //                 }
// //             })),
// //             summary: {
// //                 totalOrders,
// //                 avgDailyOrders: Math.round(totalOrders / dateData.length),
// //                 peakDay: dateData.reduce((prev, current) => 
// //                     prev.orders > current.orders ? prev : current
// //                 ),
// //                 avgOrderValue: Math.round(
// //                     dateData.reduce((sum, item) => sum + item.revenue, 0) / 
// //                     dateData.reduce((sum, item) => sum + item.orders, 0)
// //                 )
// //             },
// //             byTimeSlot: [
// //                 { time: '11AM-1PM', label: 'Dine-in', orders: Math.round(totalOrders * 0.35), color: '#f59e0b' },
// //                 { time: '1PM-4PM', label: 'Takeaway', orders: Math.round(totalOrders * 0.15), color: '#3b82f6' },
// //                 { time: '4PM-7PM', label: 'Delivery', orders: Math.round(totalOrders * 0.20), color: '#8b5cf6' },
// //                 { time: '7PM-10PM', label: 'Table', orders: Math.round(totalOrders * 0.30), color: '#ef4444' }
// //             ],
// //             byDay: [
// //                 { day: 'Monday', orders: Math.round(totalOrders * 0.14), growth: 5.2 },
// //                 { day: 'Tuesday', orders: Math.round(totalOrders * 0.15), growth: 7.8 },
// //                 { day: 'Wednesday', orders: Math.round(totalOrders * 0.16), growth: 3.4 },
// //                 { day: 'Thursday', orders: Math.round(totalOrders * 0.17), growth: 9.1 },
// //                 { day: 'Friday', orders: Math.round(totalOrders * 0.19), growth: 12.5 },
// //                 { day: 'Saturday', orders: Math.round(totalOrders * 0.13), growth: -2.3 },
// //                 { day: 'Sunday', orders: Math.round(totalOrders * 0.06), growth: -15.7 }
// //             ],
// //             orderStatus: [
// //                 { status: 'Completed', count: Math.round(totalOrders * 0.85), color: '#10b981' },
// //                 { status: 'Pending', count: Math.round(totalOrders * 0.08), color: '#f59e0b' },
// //                 { status: 'Cancelled', count: Math.round(totalOrders * 0.05), color: '#ef4444' },
// //                 { status: 'Refunded', count: Math.round(totalOrders * 0.02), color: '#64748b' }
// //             ]
// //         };
// //     }, [generateDateTrendData]);

// //     // Generate detailed payment mode data
// //     const generatePaymentModeData = useMemo(() => {
// //         const dateData = generateDateTrendData;
// //         const totalRevenue = dateData.reduce((sum, item) => sum + item.revenue, 0);

// //         const methods = [
// //             { name: 'UPI', description: 'Digital payments', color: '#7c3aed', icon: <CreditCardIcon size={16} />, fee: 1.2 },
// //             { name: 'Cash', description: 'Cash payments', color: '#10b981', icon: <DollarSignIcon size={16} />, fee: 0 },
// //             { name: 'Card', description: 'Credit/Debit cards', color: '#3b82f6', icon: <CreditCard size={16} />, fee: 1.8 },
// //             { name: 'Wallet', description: 'E-wallets', color: '#f59e0b', icon: <Wallet size={16} />, fee: 1.0 },
// //             { name: 'Credit', description: 'Credit accounts', color: '#ef4444', icon: <CreditCard size={16} />, fee: 0 }
// //         ];

// //         return {
// //             trend: dateData.map(item => {
// //                 const methodsData = {};
// //                 methods.forEach(method => {
// //                     const percentage = method.name === 'UPI' ? 45 :
// //                         method.name === 'Cash' ? 25 :
// //                         method.name === 'Card' ? 15 :
// //                         method.name === 'Wallet' ? 10 : 5;
// //                     methodsData[method.name] = Math.round(item.revenue * (percentage / 100));
// //                 });
// //                 return {
// //                     date: item.date,
// //                     ...methodsData
// //                 };
// //             }),
// //             summary: methods.map(method => {
// //                 const percentage = method.name === 'UPI' ? 45 :
// //                     method.name === 'Cash' ? 25 :
// //                     method.name === 'Card' ? 15 :
// //                     method.name === 'Wallet' ? 10 : 5;
// //                 const amount = Math.round(totalRevenue * (percentage / 100));
// //                 const transactions = Math.round(amount / (method.name === 'Cash' ? 500 : 800));
// //                 const processingFee = Math.round(amount * (method.fee / 100));

// //                 return {
// //                     ...method,
// //                     amount,
// //                     percentage,
// //                     transactions,
// //                     processingFee,
// //                     netAmount: amount - processingFee
// //                 };
// //             }),
// //             feeAnalysis: {
// //                 totalFees: Math.round(totalRevenue * 0.012),
// //                 avgFeePercentage: 1.2,
// //                 mostCostly: 'Card',
// //                 cheapest: 'Cash'
// //             }
// //         };
// //     }, [generateDateTrendData]);

// //     // Generate ratings and feedback data
// //     const generateRatingsData = useMemo(() => {
// //         const dateData = generateDateTrendData;
// //         const totalOrders = dateData.reduce((sum, item) => sum + item.orders, 0);

// //         return {
// //             trend: dateData.map(item => ({
// //                 date: item.date,
// //                 avgRating: 4.2 + Math.random() * 0.8,
// //                 totalReviews: Math.round(item.orders * 0.3),
// //                 positiveReviews: Math.round(item.orders * 0.25),
// //                 negativeReviews: Math.round(item.orders * 0.05)
// //             })),
// //             summary: {
// //                 overallRating: 4.5,
// //                 totalReviews: Math.round(totalOrders * 0.3),
// //                 responseRate: 85,
// //                 avgResponseTime: '2.4 hours'
// //             },
// //             distribution: [
// //                 { rating: 5, count: Math.round(totalOrders * 0.15), color: '#10b981', label: 'Excellent' },
// //                 { rating: 4, count: Math.round(totalOrders * 0.10), color: '#3b82f6', label: 'Good' },
// //                 { rating: 3, count: Math.round(totalOrders * 0.03), color: '#f59e0b', label: 'Average' },
// //                 { rating: 2, count: Math.round(totalOrders * 0.01), color: '#ef4444', label: 'Poor' },
// //                 { rating: 1, count: Math.round(totalOrders * 0.01), color: '#dc2626', label: 'Terrible' }
// //             ],
// //             feedbackCategories: [
// //                 { category: 'Food Quality', rating: 4.7, reviews: 125, color: '#10b981' },
// //                 { category: 'Delivery Time', rating: 4.2, reviews: 98, color: '#3b82f6' },
// //                 { category: 'Packaging', rating: 4.5, reviews: 87, color: '#f59e0b' },
// //                 { category: 'Customer Service', rating: 4.3, reviews: 76, color: '#8b5cf6' },
// //                 { category: 'Value for Money', rating: 4.4, reviews: 92, color: '#ec4899' }
// //             ],
// //             commonIssues: [
// //                 { issue: 'Late Delivery', count: 23, percentage: 12 },
// //                 { issue: 'Wrong Order', count: 15, percentage: 8 },
// //                 { issue: 'Food Temperature', count: 12, percentage: 6 },
// //                 { issue: 'Packaging Damaged', count: 8, percentage: 4 },
// //                 { issue: 'Payment Issues', count: 5, percentage: 3 }
// //             ]
// //         };
// //     }, [generateDateTrendData]);

// //     // ========== COMPONENTS ==========

// //     // Time Range Totals Display Component
// //     const TimeRangeTotalsDisplay = () => {
// //         const totals = calculateTimeRangeTotals;

// //         // Format number with K/M suffix
// //         const formatNumber = (num) => {
// //             if (num >= 1000000) return `₹${(num / 1000000).toFixed(1)}M`;
// //             if (num >= 1000) return `₹${(num / 1000).toFixed(0)}K`;
// //             return `₹${num}`;
// //         };

// //         const metrics = [
// //             { 
// //                 label: 'Total Revenue', 
// //                 value: formatNumber(totals[timeRange]?.revenue || 0), 
// //                 icon: <DollarSign size={14} />, 
// //                 color: '#10b981',
// //                 bgColor: '#dcfce7'
// //             },
// //             { 
// //                 label: 'Total Expenses', 
// //                 value: formatNumber(totals[timeRange]?.expenses || 0), 
// //                 icon: <Calculator size={14} />, 
// //                 color: '#ef4444',
// //                 bgColor: '#fee2e2'
// //             },
// //             { 
// //                 label: 'Total Orders', 
// //                 value: totals[timeRange]?.orders?.toLocaleString() || '0', 
// //                 icon: <ShoppingBag size={14} />, 
// //                 color: '#f59e0b',
// //                 bgColor: '#fef3c7'
// //             },
// //             { 
// //                 label: 'Avg Rating', 
// //                 value: `${totals[timeRange]?.avgRating?.toFixed(1) || '4.5'}/5`, 
// //                 icon: <StarIcon size={14} />, 
// //                 color: '#3b82f6',
// //                 bgColor: '#dbeafe'
// //             }
// //         ];

// //         return (
// //             <div style={{
// //                 display: 'grid',
// //                 gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
// //                 gap: isMobile ? '12px' : '16px',
// //                 marginTop: '16px',
// //                 padding: '16px',
// //                 background: 'white',
// //                 borderRadius: '16px',
// //                 border: '1px solid #e2e8f0',
// //                 boxShadow: '0 4px 12px rgba(0,0,0,0.04)'
// //             }}>
// //                 {metrics.map((metric, index) => (
// //                     <div key={index} style={{
// //                         textAlign: 'center',
// //                         padding: '12px',
// //                         background: metric.bgColor,
// //                         borderRadius: '12px',
// //                         border: `1px solid ${metric.color}20`
// //                     }}>
// //                         <div style={{ 
// //                             fontSize: isMobile ? '10px' : '11px', 
// //                             color: metric.color, 
// //                             fontWeight: '600', 
// //                             marginBottom: '4px',
// //                             textTransform: 'uppercase',
// //                             letterSpacing: '0.5px',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             justifyContent: 'center',
// //                             gap: '4px'
// //                         }}>
// //                             {metric.icon}
// //                             {metric.label}
// //                         </div>
// //                         <div style={{ 
// //                             fontSize: isMobile ? '18px' : '20px', 
// //                             fontWeight: '800', 
// //                             color: '#1e293b',
// //                             marginBottom: '4px'
// //                         }}>
// //                             {metric.value}
// //                         </div>
// //                         <div style={{ 
// //                             fontSize: isMobile ? '9px' : '10px', 
// //                             color: metric.color,
// //                             opacity: 0.8
// //                         }}>
// //                             {timeRange === 'yearly' ? 'Annual' : 
// //                              timeRange === 'monthly' ? 'Monthly' : 
// //                              timeRange === 'weekly' ? 'Weekly' : 'Custom'}
// //                         </div>
// //                     </div>
// //                 ))}
// //             </div>
// //         );
// //     };

// //     // Enhanced Summary Cards
// //     const SummaryCards = () => {
// //         const revenueData = generateDateTrendData;
// //         const expenseData = generateExpenseTrendData;

// //         const totalRevenue = revenueData.reduce((sum, item) => sum + item.revenue, 0);
// //         const totalOrders = revenueData.reduce((sum, item) => sum + item.orders, 0);
// //         const totalDiscount = revenueData.reduce((sum, item) => sum + item.discount, 0);
// //         const totalExpenses = expenseData.reduce((sum, item) => sum + item.totalExpenses, 0);
// //         const totalProfit = expenseData.reduce((sum, item) => sum + item.profit, 0);

// //         const getCards = () => {
// //             switch (activeView) {
// //                 case 'expenses':
// //                     return [
// //                         {
// //                             title: 'Total Expenses',
// //                             value: `₹${(totalExpenses / 1000).toFixed(0)}K`,
// //                             description: 'Total costs incurred',
// //                             icon: <Calculator size={isMobile ? 20 : 24} />,
// //                             color: colors.danger,
// //                             trend: -8.2,
// //                             bgColor: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)'
// //                         },
// //                         {
// //                             title: 'Avg Daily Expense',
// //                             value: `₹${Math.round(totalExpenses / revenueData.length)}`,
// //                             description: 'Average cost per day',
// //                             icon: <Activity size={isMobile ? 20 : 24} />,
// //                             color: colors.warning,
// //                             trend: 2.7,
// //                             bgColor: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)'
// //                         },
// //                         {
// //                             title: 'Expense Ratio',
// //                             value: `${((totalExpenses / totalRevenue) * 100).toFixed(1)}%`,
// //                             description: 'Costs as % of revenue',
// //                             icon: <Scale size={isMobile ? 20 : 24} />,
// //                             color: colors.info,
// //                             trend: -1.3,
// //                             bgColor: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)'
// //                         },
// //                         {
// //                             title: 'Waste & Expiry',
// //                             value: `₹${Math.round(totalExpenses * 0.03)}`,
// //                             description: 'Inventory losses',
// //                             icon: <AlertCircle size={isMobile ? 20 : 24} />,
// //                             color: '#8b5cf6',
// //                             trend: -15.4,
// //                             bgColor: 'linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)'
// //                         }
// //                     ];

// //                 case 'revenueExpenses':
// //                     return [
// //                         {
// //                             title: 'Total Revenue',
// //                             value: `₹${(totalRevenue / 1000).toFixed(0)}K`,
// //                             description: 'Total sales collected',
// //                             icon: <DollarSign size={isMobile ? 20 : 24} />,
// //                             color: colors.success,
// //                             trend: 12.5,
// //                             bgColor: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)'
// //                         },
// //                         {
// //                             title: 'Total Expenses',
// //                             value: `₹${(totalExpenses / 1000).toFixed(0)}K`,
// //                             description: 'Total costs incurred',
// //                             icon: <Calculator size={isMobile ? 20 : 24} />,
// //                             color: colors.danger,
// //                             trend: 8.2,
// //                             bgColor: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)'
// //                         },
// //                         {
// //                             title: 'Net Profit',
// //                             value: `₹${(totalProfit / 1000).toFixed(0)}K`,
// //                             description: 'Revenue minus expenses',
// //                             icon: <Wallet size={isMobile ? 20 : 24} />,
// //                             color: colors.info,
// //                             trend: 4.3,
// //                             bgColor: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)'
// //                         },
// //                         {
// //                             title: 'Profit Margin',
// //                             value: `${((totalProfit / totalRevenue) * 100).toFixed(1)}%`,
// //                             description: 'Profit as % of revenue',
// //                             icon: <Target size={isMobile ? 20 : 24} />,
// //                             color: '#8b5cf6',
// //                             trend: 1.7,
// //                             bgColor: 'linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)'
// //                         }
// //                     ];

// //                 case 'orders':
// //                     return [
// //                         {
// //                             title: 'Total Orders',
// //                             value: totalOrders.toLocaleString(),
// //                             description: 'Total orders placed',
// //                             icon: <ShoppingBag size={isMobile ? 20 : 24} />,
// //                             color: '#f59e0b',
// //                             trend: 8.2,
// //                             bgColor: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)'
// //                         },
// //                         {
// //                             title: 'Avg Daily Orders',
// //                             value: Math.round(totalOrders / revenueData.length),
// //                             description: 'Average orders per day',
// //                             icon: <Target size={isMobile ? 20 : 24} />,
// //                             color: '#10b981',
// //                             trend: 3.7,
// //                             bgColor: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)'
// //                         },
// //                         {
// //                             title: 'Avg Order Value',
// //                             value: `₹${Math.round(totalRevenue / totalOrders)}`,
// //                             description: 'Revenue per order',
// //                             icon: <DollarSign size={isMobile ? 20 : 24} />,
// //                             color: '#3b82f6',
// //                             trend: 2.3,
// //                             bgColor: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)'
// //                         },
// //                         {
// //                             title: 'Peak Orders',
// //                             value: revenueData.reduce((prev, current) => 
// //                                 prev.orders > current.orders ? prev : current
// //                             ).orders,
// //                             description: 'Highest daily orders',
// //                             icon: <TrendingUp size={isMobile ? 20 : 24} />,
// //                             color: '#ef4444',
// //                             trend: 15.4,
// //                             bgColor: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)'
// //                         }
// //                     ];

// //                 case 'payments':
// //                     const paymentSummary = generatePaymentModeData;
// //                     return [
// //                         {
// //                             title: 'Total Transactions',
// //                             value: paymentSummary.summary.reduce((sum, method) => sum + method.transactions, 0).toLocaleString(),
// //                             description: 'Total payment transactions',
// //                             icon: <CreditCardIcon size={isMobile ? 20 : 24} />,
// //                             color: '#7c3aed',
// //                             trend: 12.5,
// //                             bgColor: 'linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)'
// //                         },
// //                         {
// //                             title: 'Processing Fees',
// //                             value: `₹${(paymentSummary.feeAnalysis.totalFees/1000).toFixed(0)}K`,
// //                             description: 'Total payment fees',
// //                             icon: <DollarSignIcon size={isMobile ? 20 : 24} />,
// //                             color: colors.danger,
// //                             trend: -2.3,
// //                             bgColor: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)'
// //                         },
// //                         {
// //                             title: 'Most Popular',
// //                             value: 'UPI',
// //                             description: 'Most used payment method',
// //                             icon: <CreditCard size={isMobile ? 20 : 24} />,
// //                             color: '#10b981',
// //                             trend: 8.2,
// //                             bgColor: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)'
// //                         },
// //                         {
// //                             title: 'Avg Fee %',
// //                             value: `${paymentSummary.feeAnalysis.avgFeePercentage}%`,
// //                             description: 'Average transaction fee',
// //                             icon: <Percent size={isMobile ? 20 : 24} />,
// //                             color: '#f59e0b',
// //                             trend: -0.5,
// //                             bgColor: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)'
// //                         }
// //                     ];

// //                 case 'ratings':
// //                     const ratingsSummary = generateRatingsData;
// //                     return [
// //                         {
// //                             title: 'Overall Rating',
// //                             value: `${ratingsSummary.summary.overallRating}/5`,
// //                             description: 'Average customer rating',
// //                             icon: <StarIcon size={isMobile ? 20 : 24} />,
// //                             color: '#f59e0b',
// //                             trend: 0.3,
// //                             bgColor: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)'
// //                         },
// //                         {
// //                             title: 'Total Reviews',
// //                             value: ratingsSummary.summary.totalReviews.toLocaleString(),
// //                             description: 'Customer feedback received',
// //                             icon: <MessageSquare size={isMobile ? 20 : 24} />,
// //                             color: '#3b82f6',
// //                             trend: 15.4,
// //                             bgColor: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)'
// //                         },
// //                         {
// //                             title: 'Response Rate',
// //                             value: `${ratingsSummary.summary.responseRate}%`,
// //                             description: 'Feedback responded to',
// //                             icon: <UserCheck size={isMobile ? 20 : 24} />,
// //                             color: '#10b981',
// //                             trend: 2.7,
// //                             bgColor: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)'
// //                         },
// //                         {
// //                             title: 'Avg Response Time',
// //                             value: ratingsSummary.summary.avgResponseTime,
// //                             description: 'Time to respond to feedback',
// //                             icon: <Clock size={isMobile ? 20 : 24} />,
// //                             color: '#8b5cf6',
// //                             trend: -1.2,
// //                             bgColor: 'linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)'
// //                         }
// //                     ];

// //                 default: // revenue
// //                     return [
// //                         {
// //                             title: 'Total Revenue',
// //                             value: `₹${(totalRevenue / 1000).toFixed(0)}K`,
// //                             description: 'Total sales collected',
// //                             icon: <DollarSign size={isMobile ? 20 : 24} />,
// //                             color: colors.success,
// //                             trend: 12.5,
// //                             bgColor: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)'
// //                         },
// //                         {
// //                             title: 'Total Orders',
// //                             value: totalOrders.toLocaleString(),
// //                             description: 'Total orders placed',
// //                             icon: <ShoppingBag size={isMobile ? 20 : 24} />,
// //                             color: colors.primary,
// //                             trend: 8.2,
// //                             bgColor: 'linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)'
// //                         },
// //                         {
// //                             title: 'Avg Order Value',
// //                             value: `₹${Math.round(totalRevenue / totalOrders)}`,
// //                             description: 'Revenue per order',
// //                             icon: <Target size={isMobile ? 20 : 24} />,
// //                             color: colors.accent,
// //                             trend: 3.7,
// //                             bgColor: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)'
// //                         },
// //                         {
// //                             title: 'Total Discount',
// //                             value: `₹${(totalDiscount / 1000).toFixed(0)}K`,
// //                             description: 'Discounts given',
// //                             icon: <TrendingDown size={isMobile ? 20 : 24} />,
// //                             color: colors.danger,
// //                             trend: -4.3,
// //                             bgColor: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)'
// //                         }
// //                     ];
// //             }
// //         };

// //         const cards = getCards();

// //         return (
// //             <div style={{
// //                 display: 'grid',
// //                 gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
// //                 gap: isMobile ? '12px' : '20px',
// //                 marginBottom: isMobile ? '24px' : '32px'
// //             }}>
// //                 {cards.map((card, index) => (
// //                     <div key={index} style={{
// //                         background: card.bgColor,
// //                         borderRadius: '20px',
// //                         padding: isMobile ? '16px' : '24px',
// //                         boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
// //                         border: '2px solid white',
// //                         minHeight: isMobile ? '120px' : 'auto',
// //                         position: 'relative',
// //                         overflow: 'hidden',
// //                         transition: 'transform 0.3s ease',
// //                         cursor: 'pointer'
// //                     }}
// //                         onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-4px)'}
// //                         onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
// //                     >
// //                         <div style={{
// //                             position: 'absolute',
// //                             top: '-20px',
// //                             right: '-20px',
// //                             width: '80px',
// //                             height: '80px',
// //                             background: `${card.color}20`,
// //                             borderRadius: '50%'
// //                         }}></div>

// //                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px', position: 'relative', zIndex: 1 }}>
// //                             <div style={{ flex: 1 }}>
// //                                 <p style={{
// //                                     fontSize: isMobile ? '12px' : '14px',
// //                                     color: '#475569',
// //                                     marginBottom: '4px',
// //                                     fontWeight: '600',
// //                                     letterSpacing: '0.5px'
// //                                 }}>{card.title}</p>
// //                                 <p style={{
// //                                     fontSize: isMobile ? '20px' : '28px',
// //                                     fontWeight: '800',
// //                                     color: '#1e293b',
// //                                     lineHeight: 1.2,
// //                                     marginBottom: '4px',
// //                                     textShadow: '0 2px 4px rgba(0,0,0,0.1)'
// //                                 }}>{card.value}</p>
// //                                 <p style={{
// //                                     fontSize: isMobile ? '10px' : '12px',
// //                                     color: '#64748b',
// //                                     lineHeight: 1.2,
// //                                     opacity: 0.8
// //                                 }}>{isMobile ? card.description.split(' ')[0] + ' ' + card.description.split(' ')[1] + '...' : card.description}</p>
// //                             </div>
// //                             <div style={{
// //                                 width: isMobile ? '40px' : '56px',
// //                                 height: isMobile ? '40px' : '56px',
// //                                 borderRadius: '14px',
// //                                 background: 'rgba(255, 255, 255, 0.3)',
// //                                 backdropFilter: 'blur(10px)',
// //                                 border: '1px solid rgba(255, 255, 255, 0.4)',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 justifyContent: 'center',
// //                                 color: card.color,
// //                                 flexShrink: 0,
// //                                 boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
// //                             }}>
// //                                 {card.icon}
// //                             </div>
// //                         </div>
// //                         <div style={{ display: 'flex', alignItems: 'center', gap: '6px', position: 'relative', zIndex: 1 }}>
// //                             {card.trend >= 0 ?
// //                                 <TrendingUp size={isMobile ? 14 : 16} color={colors.success} /> :
// //                                 <TrendingDown size={isMobile ? 14 : 16} color={colors.danger} />
// //                             }
// //                             <span style={{
// //                                 color: card.trend >= 0 ? colors.success : colors.danger,
// //                                 fontSize: isMobile ? '13px' : '14px',
// //                                 fontWeight: '700'
// //                             }}>
// //                                 {card.trend >= 0 ? '+' : ''}{card.trend}%
// //                             </span>
// //                             <span style={{
// //                                 fontSize: isMobile ? '10px' : '12px',
// //                                 color: '#64748b',
// //                                 marginLeft: 'auto'
// //                             }}>
// //                                 vs previous
// //                             </span>
// //                         </div>
// //                     </div>
// //                 ))}
// //             </div>
// //         );
// //     };

// //     // Date Trend Chart
// //     const DateTrendChart = () => (
// //         <div style={{
// //             background: 'white',
// //             borderRadius: '24px',
// //             padding: isMobile ? '20px' : '28px',
// //             marginBottom: isMobile ? '20px' : '28px',
// //             border: '1px solid #e2e8f0',
// //             boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //             position: 'relative',
// //             overflow: 'hidden'
// //         }}>
// //             <div style={{
// //                 position: 'absolute',
// //                 top: 0,
// //                 left: 0,
// //                 right: 0,
// //                 height: '4px',
// //                 background: colors.gradient
// //             }}></div>

// //             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0' }}>
// //                 <div>
// //                     <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
// //                         <div style={{
// //                             width: '48px',
// //                             height: '48px',
// //                             borderRadius: '12px',
// //                             background: colors.gradient,
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             justifyContent: 'center',
// //                             color: 'white'
// //                         }}>
// //                             <TrendUp size={24} />
// //                         </div>
// //                         <div>
// //                             <h3 style={{
// //                                 fontSize: isMobile ? '18px' : '22px',
// //                                 fontWeight: '800',
// //                                 color: '#1e293b',
// //                                 marginBottom: '2px'
// //                             }}>
// //                                 Revenue Trend
// //                             </h3>
// //                             <p style={{
// //                                 fontSize: isMobile ? '13px' : '15px',
// //                                 color: '#64748b',
// //                                 lineHeight: 1.3
// //                             }}>
// //                                 Track your sales performance over time
// //                             </p>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //             <div style={{ height: isMobile ? '240px' : '360px' }}>
// //                 <ResponsiveContainer width="100%" height="100%">
// //                     <LineChart data={generateDateTrendData}>
// //                         <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
// //                         <XAxis
// //                             dataKey="date"
// //                             fontSize={isMobile ? 11 : 12}
// //                             axisLine={false}
// //                             tickLine={false}
// //                             tick={{ fill: '#64748b' }}
// //                         />
// //                         <YAxis
// //                             fontSize={isMobile ? 11 : 12}
// //                             axisLine={false}
// //                             tickLine={false}
// //                             tick={{ fill: '#64748b' }}
// //                             tickFormatter={(value) => `₹${(value / 1000).toFixed(0)}K`}
// //                         />
// //                         <Tooltip
// //                             formatter={(value) => [`₹${Number(value).toLocaleString()}`, 'Revenue']}
// //                         />
// //                         <Legend />
// //                         <Line
// //                             type="monotone"
// //                             dataKey="revenue"
// //                             stroke={colors.primary}
// //                             strokeWidth={3}
// //                             name="Total Revenue"
// //                             dot={{ strokeWidth: 2, r: 4 }}
// //                             activeDot={{ r: 6, strokeWidth: 0 }}
// //                         />
// //                         <Line
// //                             type="monotone"
// //                             dataKey="netRevenue"
// //                             stroke={colors.success}
// //                             strokeWidth={3}
// //                             name="Net Revenue"
// //                             dot={{ strokeWidth: 2, r: 4 }}
// //                             activeDot={{ r: 6, strokeWidth: 0 }}
// //                         />
// //                     </LineChart>
// //                 </ResponsiveContainer>
// //             </div>
// //         </div>
// //     );

// //     // Order Type Chart
// //    const OrderTypeChart = () => (
// //         <div style={{
// //             background: 'white',
// //             borderRadius: '24px',
// //             padding: isMobile ? '20px' : '28px',
// //             marginBottom: isMobile ? '20px' : '28px',
// //             border: '1px solid #e2e8f0',
// //             boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //             position: 'relative',
// //             overflow: 'hidden'
// //         }}>
// //             <div style={{
// //                 position: 'absolute',
// //                 top: 0,
// //                 left: 0,
// //                 right: 0,
// //                 height: '4px',
// //                 background: colors.gradient2
// //             }}></div>

// //             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0' }}>
// //                 <div>
// //                     <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
// //                         <div style={{
// //                             width: '48px',
// //                             height: '48px',
// //                             borderRadius: '12px',
// //                             background: colors.gradient2,
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             justifyContent: 'center',
// //                             color: 'white'
// //                         }}>
// //                             <ShoppingBag size={24} />
// //                         </div>
// //                         <div>
// //                             <h3 style={{
// //                                 fontSize: isMobile ? '18px' : '22px',
// //                                 fontWeight: '800',
// //                                 color: '#1e293b',
// //                                 marginBottom: '2px'
// //                             }}>
// //                                 Order Type Distribution
// //                             </h3>
// //                             <p style={{
// //                                 fontSize: isMobile ? '13px' : '15px',
// //                                 color: '#64748b',
// //                                 lineHeight: 1.3
// //                             }}>
// //                                 Revenue breakdown by order type
// //                             </p>
// //                         </div>
// //                     </div>
// //                 </div>
// //                 <div style={{
// //                     display: 'flex',
// //                     alignItems: 'center',
// //                     gap: '8px',
// //                     marginTop: isMobile ? '4px' : '0',
// //                     background: '#f8fafc',
// //                     padding: '8px 16px',
// //                     borderRadius: '12px',
// //                     border: '1px solid #e2e8f0'
// //                 }}>
// //                     <BarChartIcon size={20} color="#f59e0b" />
// //                     <span style={{ fontSize: '14px', color: '#475569', fontWeight: '600' }}>Revenue on Bars</span>
// //                 </div>
// //             </div>
// //             <div style={{ height: isMobile ? '280px' : '400px' }}>
// //                 <ResponsiveContainer width="100%" height="100%">
// //                     <BarChart data={generateOrderTypeData}>
// //                         <defs>
// //                             {generateOrderTypeData.map((entry, index) => (
// //                                 <linearGradient key={index} id={`colorOrder${index}`} x1="0" y1="0" x2="0" y2="1">
// //                                     <stop offset="5%" stopColor={entry.color} stopOpacity={0.8} />
// //                                     <stop offset="95%" stopColor={entry.color} stopOpacity={0.2} />
// //                                 </linearGradient>
// //                             ))}
// //                         </defs>
// //                         <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
// //                         <XAxis
// //                             dataKey="name"
// //                             fontSize={isMobile ? 11 : 12}
// //                             axisLine={false}
// //                             tickLine={false}
// //                             tick={{ fill: '#64748b' }}
// //                         />
// //                         <YAxis
// //                             fontSize={isMobile ? 11 : 12}
// //                             axisLine={false}
// //                             tickLine={false}
// //                             tick={{ fill: '#64748b' }}
// //                             tickFormatter={(value) => `₹${(value / 1000).toFixed(0)}K`}
// //                         />
// //                         <Tooltip
// //                             formatter={(value) => [`₹${Number(value).toLocaleString()}`, 'Revenue']}
// //                             contentStyle={{
// //                                 borderRadius: '12px',
// //                                 border: 'none',
// //                                 background: 'white',
// //                                 boxShadow: '0 12px 32px rgba(0,0,0,0.15)',
// //                                 fontSize: isMobile ? '12px' : '14px',
// //                                 padding: '12px'
// //                             }}
// //                             labelStyle={{ fontWeight: '600', color: colors.primary, marginBottom: '4px' }}
// //                         />
// //                         <Legend
// //                             wrapperStyle={{ paddingTop: '8px' }}
// //                         />

// //                         {/* Bar with custom label render */}
// //                         <Bar
// //                             dataKey="revenue"
// //                             name="Revenue"
// //                             radius={[8, 8, 0, 0]}
// //                             label={{
// //                                 position: 'top',
// //                                 formatter: (value) => `₹${(value / 1000).toFixed(0)}K`,
// //                                 fill: '#1e293b',
// //                                 fontSize: isMobile ? 12 : 14,
// //                                 fontWeight: 'bold',
// //                                 dy: -10 // Move label up a bit
// //                             }}
// //                         >
// //                             {generateOrderTypeData.map((entry, index) => (
// //                                 <Cell key={`cell-${index}`} fill={`url(#colorOrder${index})`} />
// //                             ))}
// //                         </Bar>
// //                     </BarChart>
// //                 </ResponsiveContainer>
// //             </div>

// //             {/* Mini statistics below the chart */}
// //             <div style={{
// //                 marginTop: '20px',
// //                 padding: '16px',
// //                 background: '#f8fafc',
// //                 borderRadius: '16px',
// //                 border: '1px solid #e2e8f0'
// //             }}>
// //                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
// //                     <div style={{ textAlign: 'center' }}>
// //                         <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>
// //                             Total Revenue
// //                         </div>
// //                         <div style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b' }}>
// //                             ₹{(generateOrderTypeData.reduce((sum, item) => sum + item.revenue, 0) / 1000).toFixed(0)}K
// //                         </div>
// //                     </div>

// //                     <div style={{ textAlign: 'center' }}>
// //                         <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>
// //                             Most Popular
// //                         </div>
// //                         <div style={{ fontSize: '16px', fontWeight: '700', color: '#7c3aed' }}>
// //                             {generateOrderTypeData.reduce((prev, current) =>
// //                                 (prev.revenue > current.revenue) ? prev : current
// //                             ).name}
// //                         </div>
// //                     </div>

// //                     <div style={{ textAlign: 'center' }}>
// //                         <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>
// //                             Avg per Type
// //                         </div>
// //                         <div style={{ fontSize: '16px', fontWeight: '700', color: '#10b981' }}>
// //                             ₹{(generateOrderTypeData.reduce((sum, item) => sum + item.revenue, 0) / generateOrderTypeData.length / 1000).toFixed(0)}K
// //                         </div>
// //                     </div>

// //                     <div style={{ textAlign: 'center' }}>
// //                         <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>
// //                             Top Share
// //                         </div>
// //                         <div style={{ fontSize: '16px', fontWeight: '700', color: '#f59e0b' }}>
// //                             {Math.max(...generateOrderTypeData.map(item => item.percentage))}%
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //     );


// //    const CategoryChart = () => (
// //     <div style={{
// //         background: 'white',
// //         borderRadius: '24px',
// //         padding: isMobile ? '20px' : '28px',
// //         marginBottom: isMobile ? '20px' : '28px',
// //         border: '1px solid #e2e8f0',
// //         boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //         position: 'relative',
// //         overflow: 'hidden'
// //     }}>
// //         <div style={{
// //             position: 'absolute',
// //             top: 0,
// //             left: 0,
// //             right: 0,
// //             height: '4px',
// //             background: colors.gradient3
// //         }}></div>

// //         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0' }}>
// //             <div>
// //                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
// //                     <div style={{
// //                         width: '48px',
// //                         height: '48px',
// //                         borderRadius: '12px',
// //                         background: colors.gradient3,
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         justifyContent: 'center',
// //                         color: 'white'
// //                     }}>
// //                         <Pizza size={24} />
// //                     </div>
// //                     <div>
// //                         <h3 style={{
// //                             fontSize: isMobile ? '18px' : '22px',
// //                             fontWeight: '800',
// //                             color: '#1e293b',
// //                             marginBottom: '2px'
// //                         }}>
// //                             Category Performance
// //                         </h3>
// //                         <p style={{
// //                             fontSize: isMobile ? '13px' : '15px',
// //                             color: '#64748b',
// //                             lineHeight: 1.3
// //                         }}>
// //                             Revenue distribution across menu categories
// //                         </p>
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //         <div style={{ height: isMobile ? '260px' : '400px' }}>
// //             <ResponsiveContainer width="100%" height="100%">
// //                 <PieChart>
// //                     <Pie
// //                         data={generateCategoryData}
// //                         cx="50%"
// //                         cy="50%"
// //                         innerRadius={isMobile ? 50 : 80}
// //                         outerRadius={isMobile ? 90 : 120}
// //                         paddingAngle={2}
// //                         dataKey="revenue"
// //                         label={(entry) => `${(entry.revenue / 1000).toFixed(0)}K (${entry.percentage}%)`}
// //                         labelLine={true}
// //                     >
// //                         {generateCategoryData.map((entry, index) => (
// //                             <Cell
// //                                 key={`cell-${index}`}
// //                                 fill={entry.color}
// //                                 stroke="white"
// //                                 strokeWidth={2}
// //                             />
// //                         ))}
// //                     </Pie>
// //                     <Tooltip
// //                         formatter={(value) => [`₹${Number(value).toLocaleString()}`, 'Revenue']}
// //                         labelFormatter={(label) => `${label}`}
// //                     />
// //                     <Legend />
// //                 </PieChart>
// //             </ResponsiveContainer>
// //         </div>
// //     </div>
// // );
// //     // Category Performance
// //     const CategoryPerformance = () => {
// //         const categoryData = generateCategoryData;
// //         const sortedCategories = [...categoryData].sort((a, b) => b.revenue - a.revenue);
// //         const bestSelling = sortedCategories[0];
// //         const worstSelling = sortedCategories[sortedCategories.length - 1];

// //         return (
// //             <div style={{
// //                 background: 'white',
// //                 borderRadius: '24px',
// //                 padding: isMobile ? '20px' : '28px',
// //                 marginBottom: isMobile ? '20px' : '28px',
// //                 border: '1px solid #e2e8f0',
// //                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //                 position: 'relative',
// //                 overflow: 'hidden'
// //             }}>
// //                 <div style={{
// //                     position: 'absolute',
// //                     top: 0,
// //                     left: 0,
// //                     right: 0,
// //                     height: '4px',
// //                     background: 'linear-gradient(90deg, #10b981, #3b82f6)'
// //                 }}></div>

// //                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '28px', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0' }}>
// //                     <div>
// //                         <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
// //                             <div style={{
// //                                 width: '48px',
// //                                 height: '48px',
// //                                 borderRadius: '12px',
// //                                 background: 'linear-gradient(135deg, #10b981 0%, #3b82f6 100%)',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 justifyContent: 'center',
// //                                 color: 'white'
// //                             }}>
// //                                 <Trophy size={24} />
// //                             </div>
// //                             <div>
// //                                 <h3 style={{
// //                                     fontSize: isMobile ? '18px' : '22px',
// //                                     fontWeight: '800',
// //                                     color: '#1e293b',
// //                                     marginBottom: '2px'
// //                                 }}>
// //                                     Category Leaders
// //                                 </h3>
// //                                 <p style={{
// //                                     fontSize: isMobile ? '13px' : '15px',
// //                                     color: '#64748b',
// //                                     lineHeight: 1.3
// //                                 }}>
// //                                     Best & worst performing categories
// //                                 </p>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>

// //                 <div style={{
// //                     display: 'grid',
// //                     gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
// //                     gap: isMobile ? '20px' : '24px',
// //                     marginBottom: isMobile ? '20px' : '32px'
// //                 }}>
// //                     {/* Best Selling Category */}
// //                     <div style={{
// //                         background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(16, 185, 129, 0.05) 100%)',
// //                         borderRadius: '20px',
// //                         padding: '24px',
// //                         border: '2px solid rgba(16, 185, 129, 0.2)',
// //                         position: 'relative',
// //                         overflow: 'hidden'
// //                     }}>
// //                         <div style={{
// //                             position: 'absolute',
// //                             top: '12px',
// //                             right: '12px',
// //                             background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
// //                             color: 'white',
// //                             padding: '6px 16px',
// //                             borderRadius: '20px',
// //                             fontSize: '12px',
// //                             fontWeight: '700',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             gap: '6px',
// //                             boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
// //                             letterSpacing: '0.5px'
// //                         }}>
// //                             <Crown size={14} />
// //                             TOP PERFORMER
// //                         </div>

// //                         <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px', marginTop: '10px' }}>
// //                             <div style={{
// //                                 width: '64px',
// //                                 height: '64px',
// //                                 borderRadius: '16px',
// //                                 background: bestSelling.color,
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 justifyContent: 'center',
// //                                 color: 'white',
// //                                 flexShrink: 0,
// //                                 boxShadow: `0 8px 24px ${bestSelling.color}40`
// //                             }}>
// //                                 {React.cloneElement(bestSelling.icon, { size: 28 })}
// //                             </div>
// //                             <div style={{ flex: 1 }}>
// //                                 <h4 style={{
// //                                     fontSize: '22px',
// //                                     fontWeight: '800',
// //                                     color: '#1e293b',
// //                                     marginBottom: '4px'
// //                                 }}>
// //                                     {bestSelling.name}
// //                                 </h4>
// //                                 <p style={{
// //                                     fontSize: '14px',
// //                                     color: '#64748b',
// //                                     lineHeight: 1.3
// //                                 }}>{bestSelling.description}</p>
// //                             </div>
// //                         </div>

// //                         <div style={{
// //                             display: 'grid',
// //                             gridTemplateColumns: 'repeat(2, 1fr)',
// //                             gap: '16px',
// //                             marginTop: '20px'
// //                         }}>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Revenue</p>
// //                                 <p style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b' }}>
// //                                     ₹{(bestSelling.revenue / 1000).toFixed(0)}K
// //                                 </p>
// //                             </div>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Market Share</p>
// //                                 <p style={{ fontSize: '20px', fontWeight: '800', color: colors.success }}>
// //                                     {bestSelling.percentage}%
// //                                 </p>
// //                             </div>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Growth</p>
// //                                 <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
// //                                     <TrendingUp size={18} color={colors.success} />
// //                                     <span style={{ fontSize: '20px', fontWeight: '800', color: colors.success }}>
// //                                         +{bestSelling.growth > 0 ? bestSelling.growth.toFixed(1) : '0.0'}%
// //                                     </span>
// //                                 </div>
// //                             </div>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Status</p>
// //                                 <div style={{
// //                                     padding: '6px 12px',
// //                                     background: '#dcfce7',
// //                                     color: '#10b981',
// //                                     borderRadius: '12px',
// //                                     fontSize: '12px',
// //                                     fontWeight: '700',
// //                                     display: 'inline-block',
// //                                     border: '1px solid #bbf7d0'
// //                                 }}>
// //                                     ⚡ Excellent
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     </div>

// //                     {/* Worst Selling Category */}
// //                     <div style={{
// //                         background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(239, 68, 68, 0.05) 100%)',
// //                         borderRadius: '20px',
// //                         padding: '24px',
// //                         border: '2px solid rgba(239, 68, 68, 0.2)',
// //                         position: 'relative',
// //                         overflow: 'hidden'
// //                     }}>
// //                         <div style={{
// //                             position: 'absolute',
// //                             top: '12px',
// //                             right: '12px',
// //                             background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
// //                             color: 'white',
// //                             padding: '6px 16px',
// //                             borderRadius: '20px',
// //                             fontSize: '12px',
// //                             fontWeight: '700',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             gap: '6px',
// //                             boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
// //                             letterSpacing: '0.5px'
// //                         }}>
// //                             <AlertCircle size={14} />
// //                             NEEDS ATTENTION
// //                         </div>

// //                         <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px', marginTop: '10px' }}>
// //                             <div style={{
// //                                 width: '64px',
// //                                 height: '64px',
// //                                 borderRadius: '16px',
// //                                 background: worstSelling.color,
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 justifyContent: 'center',
// //                                 color: 'white',
// //                                 flexShrink: 0,
// //                                 boxShadow: `0 8px 24px ${worstSelling.color}40`
// //                             }}>
// //                                 {React.cloneElement(worstSelling.icon, { size: 28 })}
// //                             </div>
// //                             <div style={{ flex: 1 }}>
// //                                 <h4 style={{
// //                                     fontSize: '22px',
// //                                     fontWeight: '800',
// //                                     color: '#1e293b',
// //                                     marginBottom: '4px'
// //                                 }}>
// //                                     {worstSelling.name}
// //                                 </h4>
// //                                 <p style={{
// //                                     fontSize: '14px',
// //                                     color: '#64748b',
// //                                     lineHeight: 1.3
// //                                 }}>{worstSelling.description}</p>
// //                             </div>
// //                         </div>

// //                         <div style={{
// //                             display: 'grid',
// //                             gridTemplateColumns: 'repeat(2, 1fr)',
// //                             gap: '16px',
// //                             marginTop: '20px'
// //                         }}>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Revenue</p>
// //                                 <p style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b' }}>
// //                                     ₹{(worstSelling.revenue / 1000).toFixed(0)}K
// //                                 </p>
// //                             </div>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Market Share</p>
// //                                 <p style={{ fontSize: '20px', fontWeight: '800', color: colors.danger }}>
// //                                     {worstSelling.percentage}%
// //                                 </p>
// //                             </div>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Growth</p>
// //                                 <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
// //                                     {worstSelling.growth > 0 ?
// //                                         <TrendingUp size={18} color={colors.success} /> :
// //                                         <TrendingDown size={18} color={colors.danger} />
// //                                     }
// //                                     <span style={{
// //                                         fontSize: '20px',
// //                                         fontWeight: '800',
// //                                         color: worstSelling.growth > 0 ? colors.success : colors.danger
// //                                     }}>
// //                                         {worstSelling.growth > 0 ? '+' : ''}{worstSelling.growth.toFixed(1)}%
// //                                     </span>
// //                                 </div>
// //                             </div>
// //                             <div>
// //                                 <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px', fontWeight: '600' }}>Action</p>
// //                                 <div style={{
// //                                     padding: '6px 12px',
// //                                     background: '#fee2e2',
// //                                     color: '#ef4444',
// //                                     borderRadius: '12px',
// //                                     fontSize: '12px',
// //                                     fontWeight: '700',
// //                                     display: 'inline-block',
// //                                     border: '1px solid #fecaca'
// //                                 }}>
// //                                     🔍 Review Menu
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         );
// //     };

// //     // Item Table
// //     const ItemTable = () => {
// //         const [filter, setFilter] = useState('all');
// //         const filteredItems = filter === 'all' 
// //             ? generateTopItemsData 
// //             : generateTopItemsData.filter(item => item.category === filter);

// //         return (
// //             <div style={{
// //                 background: 'white',
// //                 borderRadius: '24px',
// //                 padding: isMobile ? '20px' : '28px',
// //                 marginBottom: isMobile ? '20px' : '28px',
// //                 border: '1px solid #e2e8f0',
// //                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //                 position: 'relative',
// //                 overflow: 'hidden'
// //             }}>
// //                 <div style={{
// //                     position: 'absolute',
// //                     top: 0,
// //                     left: 0,
// //                     right: 0,
// //                     height: '4px',
// //                     background: colors.gradient
// //                 }}></div>

// //                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0' }}>
// //                     <div>
// //                         <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
// //                             <div style={{
// //                                 width: '48px',
// //                                 height: '48px',
// //                                 borderRadius: '12px',
// //                                 background: colors.gradient,
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 justifyContent: 'center',
// //                                 color: 'white'
// //                             }}>
// //                                 <Sparkles size={24} />
// //                             </div>
// //                             <div>
// //                                 <h3 style={{ 
// //                                     fontSize: isMobile ? '18px' : '22px', 
// //                                     fontWeight: '800', 
// //                                     color: '#1e293b', 
// //                                     marginBottom: '2px' 
// //                                 }}>
// //                                     Top Selling Items
// //                                 </h3>
// //                                 <p style={{ 
// //                                     fontSize: isMobile ? '13px' : '15px', 
// //                                     color: '#64748b',
// //                                     lineHeight: 1.3
// //                                 }}>
// //                                     Best performing menu items by revenue
// //                                 </p>
// //                             </div>
// //                         </div>
// //                     </div>
// //                     <div style={{
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         gap: '12px',
// //                         background: '#f8fafc',
// //                         padding: '8px 12px',
// //                         borderRadius: '12px',
// //                         border: '1px solid #e2e8f0'
// //                     }}>
// //                         <Filter size={18} color={colors.primary} />
// //                         <select
// //                             value={filter}
// //                             onChange={(e) => setFilter(e.target.value)}
// //                             style={{
// //                                 padding: '8px 16px',
// //                                 border: 'none',
// //                                 borderRadius: '8px',
// //                                 fontSize: '14px',
// //                                 background: 'white',
// //                                 color: '#1e293b',
// //                                 fontWeight: '500',
// //                                 cursor: 'pointer',
// //                                 outline: 'none',
// //                                 boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
// //                             }}
// //                         >
// //                             <option value="all">All Categories</option>
// //                             <option value="Biryani">Biryani</option>
// //                             <option value="Main Course">Main Course</option>
// //                             <option value="Starters">Starters</option>
// //                             <option value="Desserts">Desserts</option>
// //                             <option value="Beverages">Beverages</option>
// //                             <option value="Fast Food">Fast Food</option>
// //                         </select>
// //                     </div>
// //                 </div>

// //                 <div style={{ 
// //                     overflowX: 'auto',
// //                     borderRadius: '16px',
// //                     border: '1px solid #e2e8f0'
// //                 }}>
// //                     <table style={{ 
// //                         width: '100%', 
// //                         borderCollapse: 'separate', 
// //                         borderSpacing: 0,
// //                         minWidth: isMobile ? '600px' : '800px',
// //                         fontSize: isMobile ? '12px' : '14px'
// //                     }}>
// //                         <thead>
// //                             <tr style={{ background: '#f8fafc' }}>
// //                                 <th style={{ 
// //                                     padding: '20px 16px', 
// //                                     textAlign: 'left', 
// //                                     color: '#475569', 
// //                                     borderBottom: '2px solid #e2e8f0',
// //                                     fontWeight: '600',
// //                                     fontSize: '12px',
// //                                     letterSpacing: '0.5px'
// //                                 }}>Item</th>
// //                                 <th style={{ 
// //                                     padding: '20px 16px', 
// //                                     textAlign: 'left', 
// //                                     color: '#475569', 
// //                                     borderBottom: '2px solid #e2e8f0',
// //                                     fontWeight: '600',
// //                                     fontSize: '12px',
// //                                     letterSpacing: '0.5px'
// //                                 }}>Category</th>
// //                                 <th style={{ 
// //                                     padding: '20px 16px', 
// //                                     textAlign: 'left', 
// //                                     color: '#475569', 
// //                                     borderBottom: '2px solid #e2e8f0',
// //                                     fontWeight: '600',
// //                                     fontSize: '12px',
// //                                     letterSpacing: '0.5px'
// //                                 }}>Orders</th>
// //                                 <th style={{ 
// //                                     padding: '20px 16px', 
// //                                     textAlign: 'left', 
// //                                     color: '#475569', 
// //                                     borderBottom: '2px solid #e2e8f0',
// //                                     fontWeight: '600',
// //                                     fontSize: '12px',
// //                                     letterSpacing: '0.5px'
// //                                 }}>Revenue</th>
// //                                 <th style={{ 
// //                                     padding: '20px 16px', 
// //                                     textAlign: 'left', 
// //                                     color: '#475569', 
// //                                     borderBottom: '2px solid #e2e8f0',
// //                                     fontWeight: '600',
// //                                     fontSize: '12px',
// //                                     letterSpacing: '0.5px'
// //                                 }}>Profit</th>
// //                                 <th style={{ 
// //                                     padding: '20px 16px', 
// //                                     textAlign: 'left', 
// //                                     color: '#475569', 
// //                                     borderBottom: '2px solid #e2e8f0',
// //                                     fontWeight: '600',
// //                                     fontSize: '12px',
// //                                     letterSpacing: '0.5px'
// //                                 }}>Margin</th>
// //                             </tr>
// //                         </thead>
// //                         <tbody>
// //                             {filteredItems.map((item, index) => (
// //                                 <tr key={index} style={{ 
// //                                     borderBottom: '1px solid #f1f5f9',
// //                                     background: index % 2 === 0 ? 'white' : '#f8fafc',
// //                                     transition: 'all 0.2s'
// //                                 }}>
// //                                     <td style={{ 
// //                                         padding: '20px 16px', 
// //                                         fontWeight: '600', 
// //                                         color: '#1e293b',
// //                                         position: 'relative'
// //                                     }}>
// //                                         <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
// //                                             <div style={{
// //                                                 width: '32px',
// //                                                 height: '32px',
// //                                                 borderRadius: '8px',
// //                                                 background: colors.primary,
// //                                                 color: 'white',
// //                                                 display: 'flex',
// //                                                 alignItems: 'center',
// //                                                 justifyContent: 'center',
// //                                                 fontSize: '14px',
// //                                                 fontWeight: '700'
// //                                             }}>
// //                                                 {index + 1}
// //                                             </div>
// //                                             {item.name}
// //                                         </div>
// //                                     </td>
// //                                     <td style={{ padding: '20px 16px' }}>
// //                                         <span style={{
// //                                             padding: '6px 12px',
// //                                             background: '#f1f5f9',
// //                                             borderRadius: '8px',
// //                                             fontSize: '12px',
// //                                             color: '#475569',
// //                                             fontWeight: '500'
// //                                         }}>
// //                                             {item.category}
// //                                         </span>
// //                                     </td>
// //                                     <td style={{ 
// //                                         padding: '20px 16px', 
// //                                         fontWeight: '700', 
// //                                         color: '#1e293b',
// //                                         fontSize: '16px'
// //                                     }}>{item.orders.toLocaleString()}</td>
// //                                     <td style={{ 
// //                                         padding: '20px 16px', 
// //                                         fontWeight: '700', 
// //                                         color: '#1e293b',
// //                                         fontSize: '16px'
// //                                     }}>₹{(item.revenue/1000).toFixed(0)}K</td>
// //                                     <td style={{ 
// //                                         padding: '20px 16px', 
// //                                         fontWeight: '700', 
// //                                         color: '#1e293b',
// //                                         fontSize: '16px'
// //                                     }}>₹{(item.profit/1000).toFixed(0)}K</td>
// //                                     <td style={{ padding: '20px 16px' }}>
// //                                         <span style={{
// //                                             padding: '8px 16px',
// //                                             background: item.profitMargin > 40 ? '#dcfce7' : 
// //                                                       item.profitMargin > 20 ? '#fef3c7' : '#fee2e2',
// //                                             color: item.profitMargin > 40 ? '#10b981' : 
// //                                                   item.profitMargin > 20 ? '#d97706' : '#ef4444',
// //                                             borderRadius: '20px',
// //                                             fontSize: '13px',
// //                                             fontWeight: '700',
// //                                             display: 'inline-flex',
// //                                             alignItems: 'center',
// //                                             gap: '4px',
// //                                             border: item.profitMargin > 40 ? '1px solid #bbf7d0' : 
// //                                                    item.profitMargin > 20 ? '1px solid #fde68a' : '1px solid #fecaca'
// //                                         }}>
// //                                             {item.profitMargin > 40 ? '🔥 ' : item.profitMargin > 20 ? '⚡ ' : ''}
// //                                             {item.profitMargin}%
// //                                         </span>
// //                                     </td>
// //                                 </tr>
// //                             ))}
// //                         </tbody>
// //                     </table>
// //                 </div>
// //             </div>
// //         );
// //     };

// //     // Payment Analysis
// //     // const PaymentAnalysis = () => (
// //     //     <div style={{
// //     //         background: 'white',
// //     //         borderRadius: '24px',
// //     //         padding: isMobile ? '20px' : '28px',
// //     //         marginBottom: isMobile ? '20px' : '28px',
// //     //         border: '1px solid #e2e8f0',
// //     //         boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //     //         position: 'relative',
// //     //         overflow: 'hidden'
// //     //     }}>
// //     //         <div style={{
// //     //             position: 'absolute',
// //     //             top: 0,
// //     //             left: 0,
// //     //             right: 0,
// //     //             height: '4px',
// //     //             background: 'linear-gradient(90deg, #7c3aed, #ec4899)'
// //     //         }}></div>

// //     //         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0' }}>
// //     //             <div>
// //     //                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
// //     //                     <div style={{
// //     //                         width: '48px',
// //     //                         height: '48px',
// //     //                         borderRadius: '12px',
// //     //                         background: 'linear-gradient(135deg, #7c3aed 0%, #ec4899 100%)',
// //     //                         display: 'flex',
// //     //                         alignItems: 'center',
// //     //                         justifyContent: 'center',
// //     //                         color: 'white'
// //     //                     }}>
// //     //                         <CreditCard size={24} />
// //     //                     </div>
// //     //                     <div>
// //     //                         <h3 style={{ 
// //     //                             fontSize: isMobile ? '18px' : '22px', 
// //     //                             fontWeight: '800', 
// //     //                             color: '#1e293b', 
// //     //                             marginBottom: '2px' 
// //     //                         }}>
// //     //                             Payment Methods Analysis
// //     //                         </h3>
// //     //                         <p style={{ 
// //     //                             fontSize: isMobile ? '13px' : '15px', 
// //     //                             color: '#64748b',
// //     //                             lineHeight: 1.3
// //     //                         }}>
// //     //                             Revenue distribution by payment type
// //     //                         </p>
// //     //                     </div>
// //     //                 </div>
// //     //             </div>
// //     //         </div>
// //     //         <div style={{ height: isMobile ? '280px' : '400px' }}>
// //     //             <ResponsiveContainer width="100%" height="100%">
// //     //                 <BarChart data={generatePaymentData}>
// //     //                     <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
// //     //                     <XAxis 
// //     //                         dataKey="name" 
// //     //                         fontSize={isMobile ? 11 : 12} 
// //     //                         axisLine={false}
// //     //                         tickLine={false}
// //     //                         tick={{ fill: '#64748b' }}
// //     //                     />
// //     //                     <YAxis 
// //     //                         fontSize={isMobile ? 11 : 12} 
// //     //                         axisLine={false}
// //     //                         tickLine={false}
// //     //                         tick={{ fill: '#64748b' }}
// //     //                         tickFormatter={(value) => `₹${(value/1000).toFixed(0)}K`}
// //     //                     />
// //     //                     <Tooltip 
// //     //                         formatter={(value) => [`₹${Number(value).toLocaleString()}`, 'Amount']}
// //     //                     />
// //     //                     <Bar 
// //     //                         dataKey="amount" 
// //     //                         name="Revenue" 
// //     //                         radius={[8, 8, 0, 0]}
// //     //                     >
// //     //                         {generatePaymentData.map((entry, index) => (
// //     //                             <Cell key={`cell-${index}`} fill={entry.color} />
// //     //                         ))}
// //     //                     </Bar>
// //     //                 </BarChart>
// //     //             </ResponsiveContainer>
// //     //         </div>
// //     //     </div>
// //     // );
// // const PaymentAnalysis = () => (
// //     <div style={{
// //         background: 'white',
// //         borderRadius: '24px',
// //         padding: isMobile ? '20px' : '28px',
// //         marginBottom: isMobile ? '20px' : '28px',
// //         border: '1px solid #e2e8f0',
// //         boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //         position: 'relative',
// //         overflow: 'hidden'
// //     }}>
// //         <div style={{
// //             position: 'absolute',
// //             top: 0,
// //             left: 0,
// //             right: 0,
// //             height: '4px',
// //             background: 'linear-gradient(90deg, #7c3aed, #ec4899)'
// //         }}></div>

// //         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0' }}>
// //             <div>
// //                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
// //                     <div style={{
// //                         width: '48px',
// //                         height: '48px',
// //                         borderRadius: '12px',
// //                         background: 'linear-gradient(135deg, #7c3aed 0%, #ec4899 100%)',
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         justifyContent: 'center',
// //                         color: 'white'
// //                     }}>
// //                         <CreditCard size={24} />
// //                     </div>
// //                     <div>
// //                         <h3 style={{ 
// //                             fontSize: isMobile ? '18px' : '22px', 
// //                             fontWeight: '800', 
// //                             color: '#1e293b', 
// //                             marginBottom: '2px' 
// //                         }}>
// //                             Payment Methods Analysis
// //                         </h3>
// //                         <p style={{ 
// //                             fontSize: isMobile ? '13px' : '15px', 
// //                             color: '#64748b',
// //                             lineHeight: 1.3
// //                         }}>
// //                             Revenue distribution by payment type
// //                         </p>
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //         <div style={{ height: isMobile ? '280px' : '400px' }}>
// //             <ResponsiveContainer width="100%" height="100%">
// //                 <BarChart data={generatePaymentData}>
// //                     <defs>
// //                         {generatePaymentData.map((entry, index) => (
// //                             <linearGradient key={index} id={`colorPayment${index}`} x1="0" y1="0" x2="0" y2="1">
// //                                 <stop offset="5%" stopColor={entry.color} stopOpacity={0.8}/>
// //                                 <stop offset="95%" stopColor={entry.color} stopOpacity={0.2}/>
// //                             </linearGradient>
// //                         ))}
// //                     </defs>
// //                     <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
// //                     <XAxis 
// //                         dataKey="name" 
// //                         fontSize={isMobile ? 11 : 12} 
// //                         axisLine={false}
// //                         tickLine={false}
// //                         tick={{ fill: '#64748b' }}
// //                     />
// //                     <YAxis 
// //                         fontSize={isMobile ? 11 : 12} 
// //                         axisLine={false}
// //                         tickLine={false}
// //                         tick={{ fill: '#64748b' }}
// //                         tickFormatter={(value) => `₹${(value/1000).toFixed(0)}K`}
// //                     />
// //                     <Tooltip 
// //                         formatter={(value) => [`₹${Number(value).toLocaleString()}`, 'Amount']}
// //                         contentStyle={{ 
// //                             borderRadius: '12px', 
// //                             border: 'none',
// //                             background: 'white',
// //                             boxShadow: '0 12px 32px rgba(0,0,0,0.15)',
// //                             fontSize: isMobile ? '12px' : '14px',
// //                             padding: '12px'
// //                         }}
// //                         labelStyle={{ fontWeight: '600', color: colors.primary, marginBottom: '4px' }}
// //                     />

// //                     {/* Bar with revenue amount labels on top */}
// //                     <Bar 
// //                         dataKey="amount" 
// //                         name="Revenue" 
// //                         radius={[8, 8, 0, 0]}
// //                         label={{
// //                             position: 'top',
// //                             formatter: (value) => `₹${(value / 1000).toFixed(0)}K`,
// //                             fill: '#1e293b',
// //                             fontSize: isMobile ? 12 : 14,
// //                             fontWeight: 'bold',
// //                             dy: -10
// //                         }}
// //                     >
// //                         {generatePaymentData.map((entry, index) => (
// //                             <Cell key={`cell-${index}`} fill={`url(#colorPayment${index})`} />
// //                         ))}
// //                     </Bar>
// //                 </BarChart>
// //             </ResponsiveContainer>
// //         </div>
// //     </div>
// // );
// //     // Gross Net Chart
// //     const GrossNetChart = () => (
// //         <div style={{
// //             background: 'white',
// //             borderRadius: '24px',
// //             padding: isMobile ? '20px' : '28px',
// //             marginBottom: isMobile ? '20px' : '28px',
// //             border: '1px solid #e2e8f0',
// //             boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //             position: 'relative',
// //             overflow: 'hidden'
// //         }}>
// //             <div style={{
// //                 position: 'absolute',
// //                 top: 0,
// //                 left: 0,
// //                 right: 0,
// //                 height: '4px',
// //                 background: 'linear-gradient(90deg, #3b82f6, #8b5cf6)'
// //             }}></div>

// //             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0' }}>
// //                 <div>
// //                     <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
// //                         <div style={{
// //                             width: '48px',
// //                             height: '48px',
// //                             borderRadius: '12px',
// //                             background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             justifyContent: 'center',
// //                             color: 'white'
// //                         }}>
// //                             <Scale size={24} />
// //                         </div>
// //                         <div>
// //                             <h3 style={{
// //                                 fontSize: isMobile ? '18px' : '22px',
// //                                 fontWeight: '800',
// //                                 color: '#1e293b',
// //                                 marginBottom: '2px'
// //                             }}>
// //                                 Gross vs Net Revenue
// //                             </h3>
// //                             <p style={{
// //                                 fontSize: isMobile ? '13px' : '15px',
// //                                 color: '#64748b',
// //                                 lineHeight: 1.3
// //                             }}>
// //                                 Revenue before and after discounts
// //                             </p>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //             <div style={{ height: isMobile ? '240px' : '360px' }}>
// //                 <ResponsiveContainer width="100%" height="100%">
// //                     <ComposedChart data={generateGrossNetData}>
// //                         <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
// //                         <XAxis
// //                             dataKey="date"
// //                             fontSize={isMobile ? 11 : 12}
// //                             axisLine={false}
// //                             tickLine={false}
// //                             tick={{ fill: '#64748b' }}
// //                         />
// //                         <YAxis
// //                             fontSize={isMobile ? 11 : 12}
// //                             axisLine={false}
// //                             tickLine={false}
// //                             tick={{ fill: '#64748b' }}
// //                             tickFormatter={(value) => `₹${(value / 1000).toFixed(0)}K`}
// //                         />
// //                         <Tooltip />
// //                         <Bar dataKey="gross" fill={colors.primary} opacity={0.9} name="Gross Revenue" radius={[8, 8, 0, 0]} />
// //                         <Bar dataKey="net" fill={colors.success} name="Net Revenue" radius={[8, 8, 0, 0]} />
// //                     </ComposedChart>
// //                 </ResponsiveContainer>
// //             </div>
// //         </div>
// //     );

// //     // Discount Impact
// //     const DiscountImpact = () => (
// //         <div style={{
// //             background: 'white',
// //             borderRadius: '24px',
// //             padding: isMobile ? '20px' : '28px',
// //             marginBottom: isMobile ? '20px' : '28px',
// //             border: '1px solid #e2e8f0',
// //             boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //             position: 'relative',
// //             overflow: 'hidden'
// //         }}>
// //             <div style={{
// //                 position: 'absolute',
// //                 top: 0,
// //                 left: 0,
// //                 right: 0,
// //                 height: '4px',
// //                 background: 'linear-gradient(90deg, #f59e0b, #ec4899)'
// //             }}></div>

// //             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0' }}>
// //                 <div>
// //                     <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
// //                         <div style={{
// //                             width: '48px',
// //                             height: '48px',
// //                             borderRadius: '12px',
// //                             background: 'linear-gradient(135deg, #f59e0b 0%, #ec4899 100%)',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             justifyContent: 'center',
// //                             color: 'white'
// //                         }}>
// //                             <TrendingDown size={24} />
// //                         </div>
// //                         <div>
// //                             <h3 style={{
// //                                 fontSize: isMobile ? '18px' : '22px',
// //                                 fontWeight: '800',
// //                                 color: '#1e293b',
// //                                 marginBottom: '2px'
// //                             }}>
// //                                 Discount Impact
// //                             </h3>
// //                             <p style={{
// //                                 fontSize: isMobile ? '13px' : '15px',
// //                                 color: '#64748b',
// //                                 lineHeight: 1.3
// //                             }}>
// //                                 Revenue impact of discounts and offers
// //                             </p>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //             <div style={{ height: isMobile ? '240px' : '360px' }}>
// //                 <ResponsiveContainer width="100%" height="100%">
// //                     <AreaChart data={generateDiscountImpactData}>
// //                         <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
// //                         <XAxis
// //                             dataKey="date"
// //                             fontSize={isMobile ? 11 : 12}
// //                             axisLine={false}
// //                             tickLine={false}
// //                             tick={{ fill: '#64748b' }}
// //                         />
// //                         <YAxis
// //                             yAxisId="left"
// //                             fontSize={isMobile ? 11 : 12}
// //                             axisLine={false}
// //                             tickLine={false}
// //                             tick={{ fill: '#64748b' }}
// //                             tickFormatter={(value) => `₹${(value / 1000).toFixed(0)}K`}
// //                         />
// //                         <Tooltip />
// //                         <Area yAxisId="left" type="monotone" dataKey="revenueWithoutDiscount" stroke={colors.primary} fill={colors.primary} fillOpacity={0.1} name="Expected Revenue" strokeWidth={2} />
// //                         <Area yAxisId="left" type="monotone" dataKey="actualRevenue" stroke={colors.success} fill={colors.success} fillOpacity={0.1} name="Actual Revenue" strokeWidth={2} />
// //                     </AreaChart>
// //                 </ResponsiveContainer>
// //             </div>
// //         </div>
// //     );


// // const RevenueVsExpenses = () => {
// //     const trendData = generateExpenseTrendData;

// //     const revenueExpenseChartData = trendData.map(item => ({
// //         date: item.date,
// //         Revenue: item.revenue,
// //         Expenses: item.totalExpenses,
// //         Profit: item.profit
// //     }));

// //     return (
// //         <div style={{
// //             background: 'white',
// //             borderRadius: '24px',
// //             padding: isMobile ? '20px' : '28px',
// //             marginBottom: isMobile ? '20px' : '28px',
// //             border: '1px solid #e2e8f0',
// //             boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //             position: 'relative',
// //             overflow: 'hidden'
// //         }}>
// //             <div style={{
// //                 position: 'absolute',
// //                 top: 0,
// //                 left: 0,
// //                 right: 0,
// //                 height: '4px',
// //                 background: 'linear-gradient(90deg, #10b981, #3b82f6, #8b5cf6)'
// //             }}></div>

// //             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '28px', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0' }}>
// //                 <div>
// //                     <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
// //                         <div style={{
// //                             width: '48px',
// //                             height: '48px',
// //                             borderRadius: '12px',
// //                             background: 'linear-gradient(135deg, #10b981 0%, #3b82f6 50%, #8b5cf6 100%)',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             justifyContent: 'center',
// //                             color: 'white'
// //                         }}>
// //                             <Wallet size={24} />
// //                         </div>
// //                         <div>
// //                             <h3 style={{
// //                                 fontSize: isMobile ? '18px' : '22px',
// //                                 fontWeight: '800',
// //                                 color: '#1e293b',
// //                                 marginBottom: '2px'
// //                             }}>
// //                                 Financial Overview
// //                             </h3>
// //                             <p style={{
// //                                 fontSize: isMobile ? '13px' : '15px',
// //                                 color: '#64748b',
// //                                 lineHeight: 1.3
// //                             }}>
// //                                 Track revenue, expenses, and net profit
// //                             </p>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>

// //             <div style={{ marginBottom: '32px' }}>
// //                 <h4 style={{ fontSize: '18px', fontWeight: '800', color: '#1e293b', marginBottom: '16px' }}>
// //                     Revenue vs Expenses Trend
// //                 </h4>
// //                 <div style={{ height: isMobile ? '280px' : '400px' }}>
// //                     <ResponsiveContainer width="100%" height="100%">
// //                         <ComposedChart data={revenueExpenseChartData}>
// //                             <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
// //                             <XAxis
// //                                 dataKey="date"
// //                                 fontSize={isMobile ? 11 : 12}
// //                                 axisLine={false}
// //                                 tickLine={false}
// //                                 tick={{ fill: '#64748b' }}
// //                             />
// //                             <YAxis
// //                                 fontSize={isMobile ? 11 : 12}
// //                                 axisLine={false}
// //                                 tickLine={false}
// //                                 tick={{ fill: '#64748b' }}
// //                                 tickFormatter={(value) => `₹${(value / 1000).toFixed(0)}K`}
// //                             />
// //                             <Tooltip />
// //                             <Bar 
// //                                 dataKey="Revenue" 
// //                                 fill="#10b981" 
// //                                 name="Revenue" 
// //                                 radius={[8, 8, 0, 0]}
// //                                 label={{
// //                                     position: 'top',
// //                                     formatter: (value) => `₹${(value / 1000).toFixed(0)}K`,
// //                                     fill: '#10b981',
// //                                     fontSize: isMobile ? 10 : 11,
// //                                     fontWeight: 'bold',
// //                                     dy: -10
// //                                 }}
// //                             />
// //                             <Bar 
// //                                 dataKey="Expenses" 
// //                                 fill="#ef4444" 
// //                                 name="Expenses" 
// //                                 radius={[8, 8, 0, 0]}
// //                                 label={{
// //                                     position: 'top',
// //                                     formatter: (value) => `₹${(value / 1000).toFixed(0)}K`,
// //                                     fill: '#ef4444',
// //                                     fontSize: isMobile ? 10 : 11,
// //                                     fontWeight: 'bold',
// //                                     dy: -10
// //                                 }}
// //                             />
// //                             <Line type="monotone" dataKey="Profit" stroke="#3b82f6" strokeWidth={3} name="Profit" dot={{ strokeWidth: 2, r: 4 }} />
// //                         </ComposedChart>
// //                     </ResponsiveContainer>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // }; // Expense Breakdown
// //     const ExpenseBreakdown = () => {
// //         const expenseData = generateExpenseData;
// //         const trendData = generateExpenseTrendData;

// //         return (
// //             <div style={{
// //                 background: 'white',
// //                 borderRadius: '24px',
// //                 padding: isMobile ? '20px' : '28px',
// //                 marginBottom: isMobile ? '20px' : '28px',
// //                 border: '1px solid #e2e8f0',
// //                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //                 position: 'relative',
// //                 overflow: 'hidden'
// //             }}>
// //                 <div style={{
// //                     position: 'absolute',
// //                     top: 0,
// //                     left: 0,
// //                     right: 0,
// //                     height: '4px',
// //                     background: 'linear-gradient(90deg, #ef4444, #f59e0b)'
// //                 }}></div>

// //                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '28px', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0' }}>
// //                     <div>
// //                         <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
// //                             <div style={{
// //                                 width: '48px',
// //                                 height: '48px',
// //                                 borderRadius: '12px',
// //                                 background: 'linear-gradient(135deg, #ef4444 0%, #f59e0b 100%)',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 justifyContent: 'center',
// //                                 color: 'white'
// //                             }}>
// //                                 <Calculator size={24} />
// //                             </div>
// //                             <div>
// //                                 <h3 style={{
// //                                     fontSize: isMobile ? '18px' : '22px',
// //                                     fontWeight: '800',
// //                                     color: '#1e293b',
// //                                     marginBottom: '2px'
// //                                 }}>
// //                                     Expense Breakdown
// //                                 </h3>
// //                                 <p style={{
// //                                     fontSize: isMobile ? '13px' : '15px',
// //                                     color: '#64748b',
// //                                     lineHeight: 1.3
// //                                 }}>
// //                                     Detailed cost analysis by category
// //                                 </p>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>

// //                 <div style={{ marginBottom: '32px' }}>
// //                     <h4 style={{ fontSize: '18px', fontWeight: '800', color: '#1e293b', marginBottom: '16px' }}>
// //                         Expense Trend Over Time
// //                     </h4>
// //                     <div style={{ height: isMobile ? '240px' : '320px' }}>
// //                         <ResponsiveContainer width="100%" height="100%">
// //                             <AreaChart data={trendData}>
// //                                 <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
// //                                 <XAxis
// //                                     dataKey="date"
// //                                     fontSize={isMobile ? 11 : 12}
// //                                     axisLine={false}
// //                                     tickLine={false}
// //                                     tick={{ fill: '#64748b' }}
// //                                 />
// //                                 <YAxis
// //                                     fontSize={isMobile ? 11 : 12}
// //                                     axisLine={false}
// //                                     tickLine={false}
// //                                     tick={{ fill: '#64748b' }}
// //                                     tickFormatter={(value) => `₹${(value / 1000).toFixed(0)}K`}
// //                                 />
// //                                 <Tooltip />
// //                                 <Area type="monotone" dataKey="totalExpenses" stroke="#ef4444" fill="#ef4444" fillOpacity={0.1} name="Total Expenses" strokeWidth={2} />
// //                             </AreaChart>
// //                         </ResponsiveContainer>
// //                     </div>
// //                 </div>

// //                 <div style={{
// //                     display: 'grid',
// //                     gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
// //                     gap: isMobile ? '24px' : '32px'
// //                 }}>
// //                     <div style={{ height: isMobile ? '320px' : '480px' }}>
// //                         <h4 style={{ fontSize: '18px', fontWeight: '800', color: '#1e293b', marginBottom: '16px' }}>
// //                             Expense Distribution
// //                         </h4>
// //                         <ResponsiveContainer width="100%" height="100%">
// //                             <BarChart data={expenseData.expenses} layout="vertical">
// //                                 <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" horizontal={true} />
// //                                 <XAxis
// //                                     type="number"
// //                                     fontSize={isMobile ? 11 : 12}
// //                                     axisLine={false}
// //                                     tickLine={false}
// //                                     tick={{ fill: '#64748b' }}
// //                                     tickFormatter={(value) => `₹${(value / 1000).toFixed(0)}K`}
// //                                 />
// //                                 <YAxis
// //                                     type="category"
// //                                     dataKey="category"
// //                                     width={isMobile ? 100 : 140}
// //                                     fontSize={isMobile ? 11 : 12}
// //                                     axisLine={false}
// //                                     tickLine={false}
// //                                     tick={{ fill: '#64748b' }}
// //                                 />
// //                                 <Tooltip />
// //                                 <Bar dataKey="amount" name="Amount" radius={[0, 8, 8, 0]}>
// //                                     {expenseData.expenses.map((entry, index) => (
// //                                         <Cell key={`cell-${index}`} fill={entry.color} />
// //                                     ))}
// //                                 </Bar>
// //                             </BarChart>
// //                         </ResponsiveContainer>
// //                     </div>

// //                     <div>
// //                         <h4 style={{ fontSize: '18px', fontWeight: '800', color: '#1e293b', marginBottom: '16px' }}>
// //                             Expense Categories
// //                         </h4>
// //                         <div style={{
// //                             maxHeight: isMobile ? '320px' : '480px',
// //                             overflowY: 'auto',
// //                             paddingRight: '8px'
// //                         }}>
// //                             <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
// //                                 {expenseData.expenses.map((expense, index) => (
// //                                     <div key={index} style={{
// //                                         padding: '20px',
// //                                         background: '#f8fafc',
// //                                         borderRadius: '16px',
// //                                         borderLeft: `4px solid ${expense.color}`,
// //                                         transition: 'all 0.3s ease',
// //                                         cursor: 'pointer'
// //                                     }}
// //                                         onMouseEnter={e => e.currentTarget.style.transform = 'translateX(4px)'}
// //                                         onMouseLeave={e => e.currentTarget.style.transform = 'translateX(0)'}
// //                                     >
// //                                         <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
// //                                             <div style={{
// //                                                 width: '44px',
// //                                                 height: '44px',
// //                                                 borderRadius: '10px',
// //                                                 background: `${expense.color}20`,
// //                                                 display: 'flex',
// //                                                 alignItems: 'center',
// //                                                 justifyContent: 'center',
// //                                                 color: expense.color,
// //                                                 flexShrink: 0
// //                                             }}>
// //                                                 {React.cloneElement(expense.icon, { size: 20 })}
// //                                             </div>
// //                                             <div style={{ flex: 1 }}>
// //                                                 <div style={{ fontSize: '16px', fontWeight: '700', color: '#1e293b' }}>
// //                                                     {expense.category}
// //                                                 </div>
// //                                                 <div style={{ fontSize: '12px', color: '#64748b' }}>
// //                                                     {expense.description}
// //                                                 </div>
// //                                             </div>
// //                                             <div style={{ textAlign: 'right' }}>
// //                                                 <div style={{ fontSize: '18px', fontWeight: '800', color: '#1e293b' }}>
// //                                                     {expense.percentage}%
// //                                                 </div>
// //                                                 <div style={{ fontSize: '14px', color: '#64748b', fontWeight: '600' }}>
// //                                                     ₹{(expense.amount / 1000).toFixed(0)}K
// //                                                 </div>
// //                                             </div>
// //                                         </div>
// //                                         <div style={{ fontSize: '11px', color: '#94a3b8', fontStyle: 'italic' }}>
// //                                             {expense.details}
// //                                         </div>
// //                                     </div>
// //                                 ))}
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         );
// //     };

// //     // ========== NEW COMPONENTS FOR ORDERS, PAYMENTS, RATINGS ==========

// //     // Orders Analysis Component
// //  // Orders Analysis Component with Bar Labels
// // const OrdersAnalysis = () => {
// //     const ordersData = generateOrdersData;

// //     return (
// //         <div style={{
// //             background: 'white',
// //             borderRadius: '24px',
// //             padding: isMobile ? '20px' : '28px',
// //             marginBottom: isMobile ? '20px' : '28px',
// //             border: '1px solid #e2e8f0',
// //             boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //             position: 'relative',
// //             overflow: 'hidden'
// //         }}>
// //             <div style={{
// //                 position: 'absolute',
// //                 top: 0,
// //                 left: 0,
// //                 right: 0,
// //                 height: '4px',
// //                 background: 'linear-gradient(90deg, #f59e0b, #10b981)'
// //             }}></div>

// //             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0' }}>
// //                 <div>
// //                     <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
// //                         <div style={{
// //                             width: '48px',
// //                             height: '48px',
// //                             borderRadius: '12px',
// //                             background: 'linear-gradient(135deg, #f59e0b 0%, #10b981 100%)',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             justifyContent: 'center',
// //                             color: 'white'
// //                         }}>
// //                             <ShoppingBag size={24} />
// //                         </div>
// //                         <div>
// //                             <h3 style={{ 
// //                                 fontSize: isMobile ? '18px' : '22px', 
// //                                 fontWeight: '800', 
// //                                 color: '#1e293b', 
// //                                 marginBottom: '2px' 
// //                             }}>
// //                                 Orders Analysis
// //                             </h3>
// //                             <p style={{ 
// //                                 fontSize: isMobile ? '13px' : '15px', 
// //                                 color: '#64748b',
// //                                 lineHeight: 1.3
// //                             }}>
// //                                 Order trends, patterns, and performance metrics
// //                             </p>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>

// //             {/* Charts Grid */}
// //             <div style={{
// //                 // display: 'grid',
// //                 gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
// //                 gap: isMobile ? '24px' : '32px',
// //                 marginBottom: '32px'
// //             }}>
// //                 {/* Orders Trend Chart with Order Counts */}
// //                 <div>
// //                     {/* <h4 style={{ fontSize: '18px', fontWeight: '800', color: '#1e293b', marginBottom: '16px' }}>
// //                         Orders Trend
// //                     </h4> */}
// //                     <div style={{ height: isMobile ? '280px' : '360px' }}>
// //                         <ResponsiveContainer width="100%" height="100%">
// //                             <BarChart data={ordersData.byTimeSlot}>
// //                                 <defs>
// //                                     {ordersData.byTimeSlot.map((entry, index) => (
// //                                         <linearGradient key={index} id={`colorOrderSlot${index}`} x1="0" y1="0" x2="0" y2="1">
// //                                             <stop offset="5%" stopColor={entry.color} stopOpacity={0.8} />
// //                                             <stop offset="95%" stopColor={entry.color} stopOpacity={0.2} />
// //                                         </linearGradient>
// //                                     ))}
// //                                 </defs>
// //                                 <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
// //                                 <XAxis 
// //                                     dataKey="label" 
// //                                     fontSize={isMobile ? 11 : 12}
// //                                     axisLine={false}
// //                                     tickLine={false}
// //                                     tick={{ fill: '#64748b' }}
// //                                 />
// //                                 <YAxis 
// //                                     fontSize={isMobile ? 11 : 12}
// //                                     axisLine={false}
// //                                     tickLine={false}
// //                                     tick={{ fill: '#64748b' }}
// //                                 />
// //                                 <Tooltip 
// //                                     formatter={(value) => [`${Number(value).toLocaleString()}`, 'Orders']}
// //                                     contentStyle={{
// //                                         borderRadius: '12px',
// //                                         border: 'none',
// //                                         background: 'white',
// //                                         boxShadow: '0 12px 32px rgba(0,0,0,0.15)',
// //                                         fontSize: isMobile ? '12px' : '14px',
// //                                         padding: '12px'
// //                                     }}
// //                                     labelStyle={{ fontWeight: '600', color: '#f59e0b', marginBottom: '4px' }}
// //                                 />

// //                                 {/* Bar with Order Count Labels */}
// //                                 <Bar 
// //                                     dataKey="orders" 
// //                                     name="Orders" 
// //                                     radius={[8, 8, 0, 0]}
// //                                     label={{
// //                                         position: 'top',
// //                                         formatter: (value) => value.toLocaleString(),
// //                                         fill: '#1e293b',
// //                                         fontSize: isMobile ? 12 : 14,
// //                                         fontWeight: 'bold',
// //                                         dy: -10
// //                                     }}
// //                                 >
// //                                     {ordersData.byTimeSlot.map((entry, index) => (
// //                                         <Cell key={`cell-${index}`} fill={`url(#colorOrderSlot${index})`} />
// //                                     ))}
// //                                 </Bar>
// //                             </BarChart>
// //                         </ResponsiveContainer>
// //                     </div>
// //                 </div>

// //                 {/* Orders by Day with Labels */}

// //             </div>

// //             {/* Additional Metrics Section */}

// //         </div>
// //     );
// // };

// //     // Payment Mode Analysis Component
// //    // Payment Mode Analysis Component with Amount Labels
// // const PaymentModeAnalysis = () => {
// //     const paymentData = generatePaymentModeData;

// //     return (
// //         <div style={{
// //             background: 'white',
// //             borderRadius: '24px',
// //             padding: isMobile ? '20px' : '28px',
// //             marginBottom: isMobile ? '20px' : '28px',
// //             border: '1px solid #e2e8f0',
// //             boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //             position: 'relative',
// //             overflow: 'hidden'
// //         }}>
// //             <div style={{
// //                 position: 'absolute',
// //                 top: 0,
// //                 left: 0,
// //                 right: 0,
// //                 height: '4px',
// //                 background: 'linear-gradient(90deg, #7c3aed, #3b82f6)'
// //             }}></div>

// //             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0' }}>
// //                 <div>
// //                     <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
// //                         <div style={{
// //                             width: '48px',
// //                             height: '48px',
// //                             borderRadius: '12px',
// //                             background: 'linear-gradient(135deg, #7c3aed 0%, #3b82f6 100%)',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             justifyContent: 'center',
// //                             color: 'white'
// //                         }}>
// //                             <CreditCardIcon size={24} />
// //                         </div>
// //                         <div>
// //                             <h3 style={{ 
// //                                 fontSize: isMobile ? '18px' : '22px', 
// //                                 fontWeight: '800', 
// //                                 color: '#1e293b', 
// //                                 marginBottom: '2px' 
// //                             }}>
// //                                 Payment Mode Analysis
// //                             </h3>
// //                             <p style={{ 
// //                                 fontSize: isMobile ? '13px' : '15px', 
// //                                 color: '#64748b',
// //                                 lineHeight: 1.3
// //                             }}>
// //                                 Payment method trends and fee analysis with amount labels
// //                             </p>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>

// //             {/* Charts Grid */}
// //             <div style={{
// //                 // display: 'grid',
// //                 gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
// //                 gap: isMobile ? '24px' : '32px',
// //                 marginBottom: '32px'
// //             }}>
// //                 {/* Payment Method Distribution with Amount Labels */}
// //                 <div>
// //                     {/* <h4 style={{ fontSize: '18px', fontWeight: '800', color: '#1e293b', marginBottom: '16px' }}>
// //                         Payment Distribution
// //                     </h4> */}
// //                     <div style={{ height: isMobile ? '300px' : '380px' }}>
// //                         <ResponsiveContainer width="100%" height="100%">
// //                             <BarChart data={paymentData.summary}>
// //                                 <defs>
// //                                     {paymentData.summary.map((entry, index) => (
// //                                         <linearGradient key={index} id={`colorPayment${index}`} x1="0" y1="0" x2="0" y2="1">
// //                                             <stop offset="5%" stopColor={entry.color} stopOpacity={0.8} />
// //                                             <stop offset="95%" stopColor={entry.color} stopOpacity={0.2} />
// //                                         </linearGradient>
// //                                     ))}
// //                                 </defs>
// //                                 <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
// //                                 <XAxis 
// //                                     dataKey="name" 
// //                                     fontSize={isMobile ? 11 : 12}
// //                                     axisLine={false}
// //                                     tickLine={false}
// //                                     tick={{ fill: '#64748b' }}
// //                                 />
// //                                 <YAxis 
// //                                     fontSize={isMobile ? 11 : 12}
// //                                     axisLine={false}
// //                                     tickLine={false}
// //                                     tick={{ fill: '#64748b' }}
// //                                     tickFormatter={(value) => `₹${(value/1000).toFixed(0)}K`}
// //                                 />
// //                                 <Tooltip 
// //                                     formatter={(value) => [`₹${Number(value).toLocaleString()}`, 'Amount']}
// //                                     contentStyle={{
// //                                         borderRadius: '12px',
// //                                         border: 'none',
// //                                         background: 'white',
// //                                         boxShadow: '0 12px 32px rgba(0,0,0,0.15)',
// //                                         fontSize: isMobile ? '12px' : '14px',
// //                                         padding: '12px'
// //                                     }}
// //                                     labelStyle={{ fontWeight: '600', color: colors.primary, marginBottom: '4px' }}
// //                                 />

// //                                 {/* Bar with Amount Labels */}
// //                                 <Bar 
// //                                     dataKey="amount" 
// //                                     name="Amount" 
// //                                     radius={[8, 8, 0, 0]}
// //                                     label={{
// //                                         position: 'top',
// //                                         formatter: (value) => `₹${(value / 1000).toFixed(0)}K`,
// //                                         fill: '#1e293b',
// //                                         fontSize: isMobile ? 12 : 14,
// //                                         fontWeight: 'bold',
// //                                         dy: -10
// //                                     }}
// //                                 >
// //                                     {paymentData.summary.map((entry, index) => (
// //                                         <Cell key={`cell-${index}`} fill={`url(#colorPayment${index})`} />
// //                                     ))}
// //                                 </Bar>
// //                             </BarChart>
// //                         </ResponsiveContainer>
// //                     </div>
// //                 </div>

// //                 {/* Fee Analysis with Amount Labels */}

// //             </div>

// //             {/* Payment Summary Cards */}


// //             {/* Detailed Payment Methods Table */}

// //         </div>
// //     );
// // };

// //     // Ratings & Feedback Component
// // // Ratings & Feedback Component with Count Labels
// // const RatingsAnalysis = () => {
// //     const ratingsData = generateRatingsData;

// //     return (
// //         <div style={{
// //             background: 'white',
// //             borderRadius: '24px',
// //             padding: isMobile ? '20px' : '28px',
// //             marginBottom: isMobile ? '20px' : '28px',
// //             border: '1px solid #e2e8f0',
// //             boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //             position: 'relative',
// //             overflow: 'hidden'
// //         }}>
// //             <div style={{
// //                 position: 'absolute',
// //                 top: 0,
// //                 left: 0,
// //                 right: 0,
// //                 height: '4px',
// //                 background: 'linear-gradient(90deg, #f59e0b, #10b981, #3b82f6)'
// //             }}></div>

// //             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0' }}>
// //                 <div>
// //                     <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
// //                         <div style={{
// //                             width: '48px',
// //                             height: '48px',
// //                             borderRadius: '12px',
// //                             background: 'linear-gradient(135deg, #f59e0b 0%, #10b981 50%, #3b82f6 100%)',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             justifyContent: 'center',
// //                             color: 'white'
// //                         }}>
// //                             <StarIcon size={24} />
// //                         </div>
// //                         <div>
// //                             <h3 style={{ 
// //                                 fontSize: isMobile ? '18px' : '22px', 
// //                                 fontWeight: '800', 
// //                                 color: '#1e293b', 
// //                                 marginBottom: '2px' 
// //                             }}>
// //                                 Ratings & Feedback Analysis
// //                             </h3>
// //                             <p style={{ 
// //                                 fontSize: isMobile ? '13px' : '15px', 
// //                                 color: '#64748b',
// //                                 lineHeight: 1.3
// //                             }}>
// //                                 Customer satisfaction metrics with review count labels
// //                             </p>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>

// //             {/* Charts Grid */}
// //             <div style={{
// //                 display: 'grid',
// //                 gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
// //                 gap: isMobile ? '24px' : '32px',
// //                 marginBottom: '32px'
// //             }}>
// //                 {/* Rating Distribution with Count Labels */}
// //                 <div>
// //                     <h4 style={{ fontSize: '18px', fontWeight: '800', color: '#1e293b', marginBottom: '16px' }}>
// //                         Rating Distribution
// //                     </h4>
// //                     <div style={{ height: isMobile ? '300px' : '380px' }}>
// //                         <ResponsiveContainer width="100%" height="100%">
// //                             <BarChart data={ratingsData.distribution}>
// //                                 <defs>
// //                                     {ratingsData.distribution.map((entry, index) => (
// //                                         <linearGradient key={index} id={`colorRating${index}`} x1="0" y1="0" x2="0" y2="1">
// //                                             <stop offset="5%" stopColor={entry.color} stopOpacity={0.8} />
// //                                             <stop offset="95%" stopColor={entry.color} stopOpacity={0.2} />
// //                                         </linearGradient>
// //                                     ))}
// //                                 </defs>
// //                                 <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
// //                                 <XAxis 
// //                                     dataKey="label" 
// //                                     fontSize={isMobile ? 11 : 12}
// //                                     axisLine={false}
// //                                     tickLine={false}
// //                                     tick={{ fill: '#64748b' }}
// //                                 />
// //                                 <YAxis 
// //                                     fontSize={isMobile ? 11 : 12}
// //                                     axisLine={false}
// //                                     tickLine={false}
// //                                     tick={{ fill: '#64748b' }}
// //                                 />
// //                                 <Tooltip 
// //                                     formatter={(value) => [`${Number(value).toLocaleString()}`, 'Reviews']}
// //                                     contentStyle={{
// //                                         borderRadius: '12px',
// //                                         border: 'none',
// //                                         background: 'white',
// //                                         boxShadow: '0 12px 32px rgba(0,0,0,0.15)',
// //                                         fontSize: isMobile ? '12px' : '14px',
// //                                         padding: '12px'
// //                                     }}
// //                                     labelStyle={{ fontWeight: '600', color: '#f59e0b', marginBottom: '4px' }}
// //                                 />

// //                                 {/* Bar with Review Count Labels */}
// //                                 <Bar 
// //                                     dataKey="count" 
// //                                     name="Reviews" 
// //                                     radius={[8, 8, 0, 0]}
// //                                     label={{
// //                                         position: 'top',
// //                                         formatter: (value) => value.toLocaleString(),
// //                                         fill: '#1e293b',
// //                                         fontSize: isMobile ? 12 : 14,
// //                                         fontWeight: 'bold',
// //                                         dy: -10
// //                                     }}
// //                                 >
// //                                     {ratingsData.distribution.map((entry, index) => (
// //                                         <Cell key={`cell-${index}`} fill={`url(#colorRating${index})`} />
// //                                     ))}
// //                                 </Bar>
// //                             </BarChart>
// //                         </ResponsiveContainer>
// //                     </div>

// //                     {/* Rating Summary Stats */}
// //                     <div style={{
// //                         display: 'grid',
// //                         gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
// //                         gap: isMobile ? '12px' : '16px',
// //                         marginTop: '20px'
// //                     }}>
// //                         <div style={{ textAlign: 'center' }}>
// //                             <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>
// //                                 Total Reviews
// //                             </div>
// //                             <div style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b' }}>
// //                                 {ratingsData.distribution.reduce((sum, item) => sum + item.count, 0).toLocaleString()}
// //                             </div>
// //                         </div>

// //                         <div style={{ textAlign: 'center' }}>
// //                             <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>
// //                                 Avg Rating
// //                             </div>
// //                             <div style={{ fontSize: '20px', fontWeight: '800', color: '#f59e0b' }}>
// //                                 {ratingsData.summary.overallRating}/5
// //                             </div>
// //                         </div>

// //                         <div style={{ textAlign: 'center' }}>
// //                             <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>
// //                                 5-Star Reviews
// //                             </div>
// //                             <div style={{ fontSize: '20px', fontWeight: '800', color: '#10b981' }}>
// //                                 {ratingsData.distribution[0].count.toLocaleString()}
// //                             </div>
// //                         </div>

// //                         <div style={{ textAlign: 'center' }}>
// //                             <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>
// //                                 1-Star Reviews
// //                             </div>
// //                             <div style={{ fontSize: '20px', fontWeight: '800', color: '#ef4444' }}>
// //                                 {ratingsData.distribution[4].count.toLocaleString()}
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>

// //                 {/* Category Ratings with Count Labels */}
// //                 <div>
// //                     <h4 style={{ fontSize: '18px', fontWeight: '800', color: '#1e293b', marginBottom: '16px' }}>
// //                         Category Ratings
// //                     </h4>
// //                     <div style={{ height: isMobile ? '300px' : '380px' }}>
// //                         <ResponsiveContainer width="100%" height="100%">
// //                             <BarChart data={ratingsData.feedbackCategories}>
// //                                 <defs>
// //                                     {ratingsData.feedbackCategories.map((entry, index) => (
// //                                         <linearGradient key={index} id={`colorCategory${index}`} x1="0" y1="0" x2="0" y2="1">
// //                                             <stop offset="5%" stopColor={entry.color} stopOpacity={0.8} />
// //                                             <stop offset="95%" stopColor={entry.color} stopOpacity={0.2} />
// //                                         </linearGradient>
// //                                     ))}
// //                                 </defs>
// //                                 <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
// //                                 <XAxis 
// //                                     dataKey="category" 
// //                                     fontSize={isMobile ? 11 : 12}
// //                                     axisLine={false}
// //                                     tickLine={false}
// //                                     tick={{ fill: '#64748b' }}
// //                                     angle={isMobile ? -45 : 0}
// //                                     height={isMobile ? 60 : 40}
// //                                 />
// //                                 <YAxis 
// //                                     fontSize={isMobile ? 11 : 12}
// //                                     axisLine={false}
// //                                     tickLine={false}
// //                                     tick={{ fill: '#64748b' }}
// //                                     domain={[0, 5]}
// //                                 />
// //                                 <Tooltip 
// //                                     formatter={(value, name) => {
// //                                         if (name === 'rating') {
// //                                             return [`${value}/5`, 'Rating'];
// //                                         }
// //                                         if (name === 'reviews') {
// //                                             return [`${value}`, 'Reviews'];
// //                                         }
// //                                         return [value, name];
// //                                     }}
// //                                     contentStyle={{
// //                                         borderRadius: '12px',
// //                                         border: 'none',
// //                                         background: 'white',
// //                                         boxShadow: '0 12px 32px rgba(0,0,0,0.15)',
// //                                         fontSize: isMobile ? '12px' : '14px',
// //                                         padding: '12px'
// //                                     }}
// //                                 />

// //                                 {/* Bar for Reviews Count */}
// //                                 <Bar 
// //                                     dataKey="reviews" 
// //                                     name="Reviews" 
// //                                     radius={[8, 8, 0, 0]}
// //                                     label={{
// //                                         position: 'top',
// //                                         formatter: (value) => value.toLocaleString(),
// //                                         fill: '#1e293b',
// //                                         fontSize: isMobile ? 11 : 12,
// //                                         fontWeight: 'bold',
// //                                         dy: -10
// //                                     }}
// //                                 >
// //                                     {ratingsData.feedbackCategories.map((entry, index) => (
// //                                         <Cell key={`cell-cat-${index}`} fill={`url(#colorCategory${index})`} />
// //                                     ))}
// //                                 </Bar>
// //                             </BarChart>
// //                         </ResponsiveContainer>
// //                     </div>

// //                     {/* Category Rating Summary */}
// //                     <div style={{
// //                         display: 'grid',
// //                         gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
// //                         gap: '12px',
// //                         marginTop: '20px'
// //                     }}>
// //                         <div style={{ textAlign: 'center' }}>
// //                             <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>
// //                                 Best Category
// //                             </div>
// //                             <div style={{ fontSize: '16px', fontWeight: '800', color: '#10b981' }}>
// //                                 Food Quality
// //                             </div>
// //                             <div style={{ fontSize: '14px', color: '#64748b' }}>
// //                                 {Math.max(...ratingsData.feedbackCategories.map(c => c.rating)).toFixed(1)}/5
// //                             </div>
// //                         </div>

// //                         <div style={{ textAlign: 'center' }}>
// //                             <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>
// //                                 Most Reviewed
// //                             </div>
// //                             <div style={{ fontSize: '16px', fontWeight: '800', color: '#3b82f6' }}>
// //                                 Food Quality
// //                             </div>
// //                             <div style={{ fontSize: '14px', color: '#64748b' }}>
// //                                 {Math.max(...ratingsData.feedbackCategories.map(c => c.reviews)).toLocaleString()} reviews
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>

// //             {/* Additional Metrics */}
// //             <div style={{
// //                 display: 'grid',
// //                 gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
// //                 gap: '24px',
// //                 marginTop: '32px'
// //             }}>
// //                 {/* Common Issues with Count Labels */}
// //                 <div style={{ 
// //                     background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)', 
// //                     borderRadius: '16px', 
// //                     padding: '24px',
// //                     border: '1px solid #e2e8f0'
// //                 }}>
// //                     <h4 style={{ fontSize: '18px', fontWeight: '800', color: '#1e293b', marginBottom: '20px' }}>Common Issues</h4>
// //                     <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
// //                         {ratingsData.commonIssues.map((issue, index) => (
// //                             <div key={index} style={{ 
// //                                 display: 'flex', 
// //                                 alignItems: 'center', 
// //                                 justifyContent: 'space-between',
// //                                 padding: '12px 16px',
// //                                 background: 'white',
// //                                 borderRadius: '12px',
// //                                 border: '1px solid #e2e8f0'
// //                             }}>
// //                                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
// //                                     <div style={{
// //                                         width: '32px',
// //                                         height: '32px',
// //                                         borderRadius: '8px',
// //                                         background: index === 0 ? '#ef4444' : 
// //                                                   index === 1 ? '#f59e0b' : 
// //                                                   index === 2 ? '#3b82f6' : 
// //                                                   index === 3 ? '#8b5cf6' : '#10b981',
// //                                         color: 'white',
// //                                         display: 'flex',
// //                                         alignItems: 'center',
// //                                         justifyContent: 'center',
// //                                         fontSize: '14px',
// //                                         fontWeight: '700'
// //                                     }}>
// //                                         {index + 1}
// //                                     </div>
// //                                     <span style={{ fontSize: '14px', color: '#475569', fontWeight: '600' }}>{issue.issue}</span>
// //                                 </div>
// //                                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
// //                                     <span style={{ fontSize: '18px', fontWeight: '800', color: '#1e293b' }}>{issue.count}</span>
// //                                     <div style={{ 
// //                                         width: '100px', 
// //                                         height: '8px', 
// //                                         background: '#e2e8f0', 
// //                                         borderRadius: '4px',
// //                                         overflow: 'hidden'
// //                                     }}>
// //                                         <div style={{ 
// //                                             width: `${issue.percentage}%`, 
// //                                             height: '100%', 
// //                                             background: index === 0 ? '#ef4444' : 
// //                                                       index === 1 ? '#f59e0b' : 
// //                                                       index === 2 ? '#3b82f6' : 
// //                                                       index === 3 ? '#8b5cf6' : '#10b981'
// //                                         }}></div>
// //                                     </div>
// //                                     <span style={{ 
// //                                         fontSize: '12px', 
// //                                         color: '#64748b',
// //                                         minWidth: '40px',
// //                                         textAlign: 'right'
// //                                     }}>
// //                                         {issue.percentage}%
// //                                     </span>
// //                                 </div>
// //                             </div>
// //                         ))}
// //                     </div>
// //                 </div>

// //                 {/* Rating Trend with Stats */}
// //                 <div style={{ 
// //                     background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)', 
// //                     borderRadius: '16px', 
// //                     padding: '24px',
// //                     border: '1px solid #e2e8f0'
// //                 }}>
// //                     <h4 style={{ fontSize: '18px', fontWeight: '800', color: '#1e293b', marginBottom: '20px' }}>Rating Performance</h4>
// //                     <div style={{ height: '200px', marginBottom: '24px' }}>
// //                         <ResponsiveContainer width="100%" height="100%">
// //                             <LineChart data={ratingsData.trend}>
// //                                 <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
// //                                 <XAxis dataKey="date" fontSize={12} />
// //                                 <YAxis domain={[0, 5]} fontSize={12} />
// //                                 <Tooltip />
// //                                 <Line 
// //                                     type="monotone" 
// //                                     dataKey="avgRating" 
// //                                     stroke="#10b981" 
// //                                     strokeWidth={3}
// //                                     dot={{ strokeWidth: 2, r: 4 }}
// //                                     activeDot={{ r: 6 }}
// //                                 />
// //                             </LineChart>
// //                         </ResponsiveContainer>
// //                     </div>

// //                     {/* Performance Stats */}
// //                     <div style={{
// //                         display: 'grid',
// //                         gridTemplateColumns: 'repeat(2, 1fr)',
// //                         gap: '16px',
// //                         marginTop: '20px'
// //                     }}>
// //                         <div style={{ textAlign: 'center' }}>
// //                             <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>
// //                                 Response Rate
// //                             </div>
// //                             <div style={{ 
// //                                 fontSize: '24px', 
// //                                 fontWeight: '800', 
// //                                 color: '#10b981',
// //                                 marginBottom: '4px'
// //                             }}>
// //                                 {ratingsData.summary.responseRate}%
// //                             </div>
// //                         </div>

// //                         <div style={{ textAlign: 'center' }}>
// //                             <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>
// //                                 Response Time
// //                             </div>
// //                             <div style={{ 
// //                                 fontSize: '20px', 
// //                                 fontWeight: '800', 
// //                                 color: '#3b82f6',
// //                                 marginBottom: '4px'
// //                             }}>
// //                                 {ratingsData.summary.avgResponseTime}
// //                             </div>
// //                         </div>

// //                         <div style={{ textAlign: 'center' }}>
// //                             <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>
// //                                 Positive Reviews
// //                             </div>
// //                             <div style={{ 
// //                                 fontSize: '20px', 
// //                                 fontWeight: '800', 
// //                                 color: '#f59e0b',
// //                                 marginBottom: '4px'
// //                             }}>
// //                                 {ratingsData.trend.reduce((sum, item) => sum + item.positiveReviews, 0).toLocaleString()}
// //                             </div>
// //                         </div>

// //                         <div style={{ textAlign: 'center' }}>
// //                             <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>
// //                                 Negative Reviews
// //                             </div>
// //                             <div style={{ 
// //                                 fontSize: '20px', 
// //                                 fontWeight: '800', 
// //                                 color: '#ef4444',
// //                                 marginBottom: '4px'
// //                             }}>
// //                                 {ratingsData.trend.reduce((sum, item) => sum + item.negativeReviews, 0).toLocaleString()}
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// //     // View Toggles
// //     const ViewToggles = () => (
// //         <div style={{
// //             marginTop: '16px',
// //             display: 'flex',
// //             gap: '4px',
// //             background: '#f8fafc',
// //             padding: '6px',
// //             borderRadius: '16px',
// //             border: '1px solid #e2e8f0',
// //             boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
// //             justifyContent: isMobile ? 'space-around' : 'flex-start',
// //             overflowX: isMobile ? 'auto' : 'visible'
// //         }}>
// //             {[
// //                 { key: 'revenueExpenses', label: 'Financials', icon: <Scale size={18} />, color: colors.info },
// //                 { key: 'revenue', label: 'Revenue', icon: <DollarSign size={18} />, color: colors.success },
// //                 { key: 'expenses', label: 'Expenses', icon: <Calculator size={18} />, color: colors.danger },
// //                 { key: 'orders', label: 'Orders', icon: <ShoppingBag size={18} />, color: '#f59e0b' },
// //                 { key: 'payments', label: 'Payments', icon: <CreditCardIcon size={18} />, color: '#7c3aed' },
// //                 { key: 'ratings', label: 'Ratings', icon: <StarIcon size={18} />, color: '#8b5cf6' }
// //             ].map(view => (
// //                 <button
// //                     key={view.key}
// //                     onClick={() => setActiveView(view.key)}
// //                     style={{
// //                         padding: isMobile ? '8px 12px' : '10px 20px',
// //                         background: activeView === view.key ? view.color : 'transparent',
// //                         color: activeView === view.key ? 'white' : '#64748b',
// //                         border: 'none',
// //                         borderRadius: '12px',
// //                         fontSize: isMobile ? '13px' : '14px',
// //                         fontWeight: '600',
// //                         cursor: 'pointer',
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         gap: '8px',
// //                         flexShrink: 0,
// //                         boxShadow: activeView === view.key ? `0 4px 12px ${view.color}40` : 'none',
// //                         transition: 'all 0.3s ease',
// //                         minWidth: isMobile ? 'auto' : '120px'
// //                     }}
// //                 >
// //                     {view.icon}
// //                     {view.label}
// //                 </button>
// //             ))}
// //         </div>
// //     );

// //     // Date Picker Modal
// //     const DatePickerModal = () => {
// //         if (!showDatePicker) return null;

// //         return (
// //             <div style={{
// //                 position: 'absolute',
// //                 top: 'calc(100% + -235px)',
// //                 left: isMobile ? '12px' : '290px',
// //                 right: isMobile ? '12px' : 'auto',
// //                 background: 'white',
// //                 padding: '12px',
// //                 borderRadius: '8px',
// //                 border: '1px solid #e2e8f0',
// //                 boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
// //                 zIndex: 1000,
// //                 width: isMobile ? 'calc(100vw - 48px)' : '300px',
// //                 maxWidth: 'calc(100vw - 48px)',
// //                 boxSizing: 'border-box'
// //             }}>
// //                 <div style={{ 
// //                     display: 'flex', 
// //                     gap: '6px', 
// //                     alignItems: 'center', 
// //                     marginBottom: '8px',
// //                     width: '100%'
// //                 }}>
// //                     <input
// //                         type="date"
// //                         value={startDate}
// //                         onChange={(e) => setStartDate(e.target.value)}
// //                         style={{
// //                             flex: 1,
// //                             padding: '6px 8px',
// //                             border: '1px solid #e2e8f0',
// //                             borderRadius: '6px',
// //                             fontSize: '12px',
// //                             outline: 'none',
// //                             width: 'calc(50% - 12px)',
// //                             boxSizing: 'border-box',
// //                             minWidth: '0'
// //                         }}
// //                     />
// //                     <span style={{ 
// //                         color: '#94a3b8', 
// //                         fontSize: '11px',
// //                         flexShrink: 0,
// //                         minWidth: '16px',
// //                         textAlign: 'center'
// //                     }}>
// //                         to
// //                     </span>
// //                     <input
// //                         type="date"
// //                         value={endDate}
// //                         onChange={(e) => setEndDate(e.target.value)}
// //                         style={{
// //                             flex: 1,
// //                             padding: '6px 8px',
// //                             border: '1px solid #e2e8f0',
// //                             borderRadius: '6px',
// //                             fontSize: '12px',
// //                             outline: 'none',
// //                             width: 'calc(50% - 12px)',
// //                             boxSizing: 'border-box',
// //                             minWidth: '0'
// //                         }}
// //                     />
// //                 </div>

// //                 {startDate && endDate && (
// //                     <div style={{
// //                         fontSize: '15px',
// //                         color: '#64748b',
// //                         marginBottom: '8px',
// //                         padding: '4px 6px',
// //                         background: '#f8fafc',
// //                         borderRadius: '4px',
// //                         display: 'flex',
// //                         justifyContent: 'center',
// //                         width: '100%',
// //                         boxSizing: 'border-box',
// //                         overflow: 'hidden'
// //                     }}>
// //                         <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
// //                             {getDaysDifference(startDate, endDate)} days
// //                         </span>
// //                     </div>
// //                 )}

// //                 <div style={{ 
// //                     display: 'flex', 
// //                     gap: '6px',
// //                     width: '100%',
// //                     boxSizing: 'border-box'
// //                 }}>
// //                     <button
// //                         onClick={handleDateRangeApply}
// //                         disabled={!startDate || !endDate}
// //                         style={{
// //                             flex: 1,
// //                             padding: '6px 8px',
// //                             background: colors.primary,
// //                             color: 'white',
// //                             border: 'none',
// //                             borderRadius: '6px',
// //                             fontSize: '12px',
// //                             cursor: (!startDate || !endDate) ? 'not-allowed' : 'pointer',
// //                             opacity: (!startDate || !endDate) ? 0.5 : 1,
// //                             minWidth: '0',
// //                             boxSizing: 'border-box'
// //                         }}
// //                     >
// //                         Apply
// //                     </button>
// //                     <button
// //                         onClick={handleDateRangeCancel}
// //                         style={{
// //                             flex: 1,
// //                             padding: '6px 8px',
// //                             background: 'transparent',
// //                             color: '#64748b',
// //                             border: '1px solid #e2e8f0',
// //                             borderRadius: '6px',
// //                             fontSize: '12px',
// //                             cursor: 'pointer',
// //                             minWidth: '0',
// //                             boxSizing: 'border-box'
// //                         }}
// //                     >
// //                         Cancel
// //                     </button>
// //                 </div>
// //             </div>
// //         );
// //     };

// //     // ========== MAIN RENDER ==========

// //     if (loading) {
// //         return (
// //             <div style={{
// //                 height: "100vh",
// //                 display: "flex",
// //                 alignItems: "center",
// //                 justifyContent: "center",
// //                 background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',

// //             }}>
// //                 <div style={{
// //                     width: '60px',
// //                     height: '60px',
// //                     border: '4px solid rgba(255, 255, 255, 0.3)',
// //                     borderTopColor: 'white',
// //                     borderRadius: '50%',
// //                     animation: 'spin 1s linear infinite'
// //                 }}></div>
// //             </div>
// //         );
// //     }

// //     return (
// //         <div style={{
// //             height: '100vh',
// //             display: 'flex',
// //             flexDirection: 'column',
// //             fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
// //             overflow: 'hidden',
// //              margin:"65px 15%",
// //         }}>
// //             {/* Header */}
// //             <div style={{
// //                 background: 'white',
// //                 padding: isMobile ? '16px 20px' : '20px 28px',
// //                 borderBottom: '0px solid #e2e8f0',
// //                 position: 'sticky',
// //                 top: '-20px',
// //                 zIndex: 100,
// //                 marginTop: '-20px',
// //                 flexShrink: 0
// //             }}>
// //                 <div style={{
// //                     display: 'flex',
// //                     justifyContent: 'space-between',
// //                     alignItems: 'center',
// //                     marginBottom: '16px'
// //                 }}>
// //                     {/* <div style={{ textAlign: 'left' }}>
// //                         <h1 style={{
// //                             fontSize: isMobile ? '20px' : '24px',
// //                             fontWeight: '800',
// //                             color: '#1e293b',
// //                             marginBottom: '2px',
// //                             background: colors.gradient,
// //                             WebkitBackgroundClip: 'text',
// //                             WebkitTextFillColor: 'transparent',
// //                             display: 'inline-block'
// //                         }}>
// //                             {isMobile ? 'Analytics' : 'Restaurant Analytics'}
// //                         </h1>
// //                     </div> */}

// //                     {isMobile && (
// //                         <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
// //                             <button
// //                                 onClick={() => setShowMobileMenu(!showMobileMenu)}
// //                                 style={{
// //                                     width: '44px',
// //                                     height: '44px',
// //                                     background: colors.gradient,
// //                                     color: 'white',
// //                                     border: 'none',
// //                                     borderRadius: '12px',
// //                                     cursor: 'pointer',
// //                                     display: 'flex',
// //                                     alignItems: 'center',
// //                                     justifyContent: 'center',
// //                                     boxShadow: '0 4px 12px rgba(124, 58, 237, 0.3)'
// //                                 }}
// //                             >
// //                                 <Menu size={22} />
// //                             </button>
// //                         </div>
// //                     )}
// //                 </div>

// //                 {/* Time Range + Export/Reset */}
// //                 <div style={{
// //                     display: 'flex',
// //                     flexDirection: isMobile ? 'column' : 'row',
// //                     gap: isMobile ? '12px' : '16px',
// //                     alignItems: 'center',
// //                     justifyContent: 'space-between',
// //                     position: 'relative'
// //                 }}>
// //                     {/* Time Range Selector */}
// //                    {/* Time Range Selector */}
// // <div style={{
// //     display: 'flex',
// //     gap: '4px',
// //     background: '#f8fafc',
// //     padding: '6px',
// //     borderRadius: '16px',
// //     border: '1px solid #e2e8f0',
// //     boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
// //     width: isMobile ? '100%' : 'auto',
// //     flexWrap: 'wrap',
// //     position: 'relative'
// // }}>
// //     {[
// //         { key: 'yearly', label: isMobile ? 'Year' : 'Yearly', icon: <CalendarIcon size={16} /> },
// //         { key: 'monthly', label: isMobile ? 'Month' : 'Monthly', icon: <CalendarIcon size={16} /> },
// //         { key: 'weekly', label: isMobile ? 'Week' : 'Weekly', icon: <CalendarIcon size={16} /> },
// //         { key: 'today', label: isMobile ? 'Today' : 'Today', icon: <Clock size={16} /> },
// //         { key: 'custom', label: isMobile ? 'Custom' : 'Custom Range', icon: <CalendarIcon size={16} /> }
// //     ].map(range => (
// //         <button
// //             key={range.key}
// //             onClick={() => {
// //                 const today = new Date();

// //                 if (range.key === 'custom') {
// //                     setTimeRange('custom');
// //                     setShowDatePicker(!showDatePicker);
// //                 } else if (range.key === 'today') {
// //                     setTimeRange('today');
// //                     setShowDatePicker(false);
// //                     // Set both start and end date to today
// //                     const todayStr = today.toISOString().split('T')[0];
// //                     setStartDate(todayStr);
// //                     setEndDate(todayStr);
// //                 } else {
// //                     setTimeRange(range.key);
// //                     setShowDatePicker(false);
// //                     const start = new Date();
// //                     if (range.key === 'weekly') start.setDate(today.getDate() - 7);
// //                     else if (range.key === 'monthly') start.setDate(today.getDate() - 30);
// //                     else if (range.key === 'yearly') start.setFullYear(today.getFullYear() - 1);
// //                     setStartDate(start.toISOString().split('T')[0]);
// //                     setEndDate(today.toISOString().split('T')[0]);
// //                 }
// //             }}
// //             style={{
// //                 padding: isMobile ? '8px 12px' : '10px 16px',
// //                 background: timeRange === range.key ? 
// //                     (range.key === 'today' ? colors.success : colors.gradient) : 'transparent',
// //                 color: timeRange === range.key ? 'white' : '#64748b',
// //                 border: 'none',
// //                 borderRadius: '12px',
// //                 fontSize: isMobile ? '12px' : '14px',
// //                 fontWeight: timeRange === range.key ? '600' : '500',
// //                 cursor: 'pointer',
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 gap: '6px',
// //                 whiteSpace: 'nowrap',
// //                 flex: isMobile ? '1' : 'none',
// //                 position: 'relative',
// //                 zIndex: 1
// //             }}
// //         >
// //             {range.icon}
// //             {range.label}
// //         </button>
// //     ))}
// // </div>

// //                     {/* Export and Reset Buttons */}
// //                     <div style={{ display: 'flex', gap: '8px', width: isMobile ? '100%' : 'auto' }}>
// //                         <button
// //                             onClick={handleReset}
// //                             disabled={resetting}
// //                             style={{
// //                                 padding: isMobile ? '10px 16px' : '12px 20px',
// //                                 background: resetting ? '#94a3b8' : '#f59e0b',
// //                                 color: 'white',
// //                                 border: 'none',
// //                                 borderRadius: '12px',
// //                                 fontSize: isMobile ? '13px' : '14px',
// //                                 fontWeight: '600',
// //                                 cursor: resetting ? 'not-allowed' : 'pointer',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 gap: '8px',
// //                                 flex: isMobile ? 1 : 'none',
// //                                 justifyContent: 'center'
// //                             }}
// //                         >
// //                             <RotateCcw size={isMobile ? 16 : 18} className={resetting ? 'spin' : ''} />
// //                             {resetting ? '...' : 'Reset'}
// //                         </button>
// //                         <button
// //                             onClick={() => {
// //                                 // Export functionality
// //                                 const exportData = generateDateTrendData;
// //                                 const ws = XLSX.utils.json_to_sheet(exportData);
// //                                 const wb = XLSX.utils.book_new();
// //                                 XLSX.utils.book_append_sheet(wb, ws, "Report");
// //                                 XLSX.writeFile(wb, `Analytics_${timeRange}_${new Date().toISOString().split('T')[0]}.xlsx`);
// //                             }}
// //                             style={{
// //                                 padding: isMobile ? '10px 16px' : '12px 20px',
// //                                 background: colors.gradient,
// //                                 color: 'white',
// //                                 border: 'none',
// //                                 borderRadius: '12px',
// //                                 fontSize: isMobile ? '13px' : '14px',
// //                                 fontWeight: '600',
// //                                 cursor: 'pointer',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 gap: '8px',
// //                                 flex: isMobile ? 1 : 'none',
// //                                 justifyContent: 'center'
// //                             }}
// //                         >
// //                             <Download size={isMobile ? 16 : 18} />
// //                             Export
// //                         </button>
// //                     </div>
// //                 </div>

// //                 {/* Time Range Totals Display - Shows totals for selected time range */}
// //                 <TimeRangeTotalsDisplay />

// //                 {/* View Toggles */}
// //                 <ViewToggles />

// //                 {/* Date Picker Modal */}
// //                 <DatePickerModal />
// //             </div>

// //             {/* Content Area */}
// //             <div style={{
// //                 flex: 1,
// //                 overflowY: 'auto',
// //                 overflowX: 'hidden',
// //                 marginBottom: '70px',
// //                 padding: isMobile ? '20px' : '28px',
// //                 position: 'relative',
// //                 WebkitOverflowScrolling: 'touch'
// //             }}>
// //                 {/* Enhanced Summary Cards - Show in all views */}
// //                 <SummaryCards />

// //                 {/* Render content based on active view */}
// //                 {activeView === 'revenueExpenses' && (
// //                     <>

// //                         <RevenueVsExpenses />
// //                     </>
// //                 )}

// //                 {activeView === 'revenue' && (
// //                     <>
// //                         <DateTrendChart />
// //                         <OrderTypeChart />
// //                         <CategoryChart />
// //                         <CategoryPerformance />
// //                         <ItemTable />
// //                         <ItemPerformanceHighlights />
// //                         <PaymentAnalysis />
// //                         <GrossNetChart />
// //                         <DiscountImpact />
// //                     </>
// //                 )}

// //                 {activeView === 'expenses' && (
// //                     <>
// //                         <ExpenseBreakdown />
// //                     </>
// //                 )}

// //                 {activeView === 'orders' && <OrdersAnalysis />}
// //                 {activeView === 'payments' && <PaymentModeAnalysis />}
// //                 {activeView === 'ratings' && <RatingsAnalysis />}

// //                 {/* Bottom padding */}
// //                 <div style={{ height: isMobile ? '100px' : '60px' }}></div>
// //             </div>

// //             <style>{`
// //                 @keyframes spin {
// //                     0% { transform: rotate(0deg); }
// //                     100% { transform: rotate(360deg); }
// //                 }
// //                 .spin {
// //                     animation: spin 1s linear infinite;
// //                 }
// //                 ::-webkit-scrollbar { display: none; }
// //             `}</style>
// //         </div>
// //     );
// // };

// // export default FoodDashboard;




// import React, { useEffect, useState, useRef } from "react";
// import {
//     DollarSign, ShoppingBag, Calculator, Star as StarIcon,
//     TrendingUp, TrendingDown, Download, Sparkles, ChefHat
// } from 'lucide-react';
// import axios from "axios";
// import * as XLSX from "xlsx";
// import "./FoodDashboard.css"
// import FoodOffersSection from "./FoodOffersSection";
// import FoodQuickLinksSection from "./FoodQuickLinksSection";
// import { Link } from "react-router-dom";


// const Dashboard = () => {
//     const [vendorId, setVendorId] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [data, setData] = useState(null);
//     const [isMobile, setIsMobile] = useState(false);
//     const [hoveredMetric, setHoveredMetric] = useState(null);
//     const mainRef = useRef(null);

//     // Responsive check
//     useEffect(() => {
//         const checkMobile = () => setIsMobile(window.innerWidth < 768);
//         checkMobile();
//         window.addEventListener('resize', checkMobile);
//         return () => window.removeEventListener('resize', checkMobile);
//     }, []);

//     // Get vendor ID
//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         if (storedVendorId) setVendorId(storedVendorId);
//     }, []);

//     // Fetch data
//     const fetchData = async () => {
//         if (!vendorId) return;
//         setLoading(true);
//         try {
//             const token = localStorage.getItem("authToken");
//             if (!token) {
//                 setLoading(false);
//                 return;
//             }
//             const res = await axios.get(
//                 `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/orders/statistics/dashboard/${vendorId}`,
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );
//             setData(res.data);
//             setLoading(false);
//         } catch (err) {
//             console.error("Error fetching report:", err);
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchData();
//     }, [vendorId]);

//     // Export function
//     const handleExport = () => {
//         const totals = {
//             revenue: 27700,
//             expenses: 18000,
//             orders: 309,
//             rating: 4.5
//         };

//         const exportData = [{
//             Date: new Date().toLocaleDateString('en-IN'),
//             Revenue: `₹${totals.revenue.toLocaleString()}`,
//             Expenses: `₹${totals.expenses.toLocaleString()}`,
//             Orders: totals.orders,
//             Rating: `${totals.rating}/5`,
//             'Net Profit': `₹${(totals.revenue - totals.expenses).toLocaleString()}`
//         }];

//         const ws = XLSX.utils.json_to_sheet(exportData);
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, "Today's Summary");
//         const currentDate = new Date().toISOString().split('T')[0];
//         XLSX.writeFile(wb, `Today_Summary_${currentDate}.xlsx`);
//     };

//     // ========== RENDER FUNCTIONS ==========

//     const renderLoading = () => (
//         <div style={{
//             height: "100vh",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
//         }}>
//             <div style={{
//                 textAlign: 'center'
//             }}>
//                 <div style={{
//                     width: '50px',
//                     height: '50px',
//                     border: '3px solid rgba(255, 255, 255, 0.3)',
//                     borderTopColor: 'white',
//                     borderRadius: '50%',
//                     animation: 'spin 1s linear infinite',
//                     margin: '0 auto 16px'
//                 }}></div>
//                 <div style={{
//                     fontSize: '16px',
//                     fontWeight: '600',
//                     color: 'white',
//                     opacity: 0.9
//                 }}>
//                     Loading dashboard...
//                 </div>
//             </div>
//         </div>
//     );

//     const renderHeaderSection = () => {
//         const totals = {
//             revenue: 27700,
//             expenses: 18000,
//             orders: 309,
//             rating: 4.5
//         };

//         const formatNumber = (num) => {
//             if (num >= 1000) return `₹${(num / 1000).toFixed(1)}K`;
//             return `₹${num}`;
//         };

//         const metrics = [
//             {
//                 label: 'Revenue',
//                 value: formatNumber(totals.revenue || 0),
//                 icon: <DollarSign size={18} />,
//                 trend: '+12.5%',
//                 trendIcon: <TrendingUp size={12} />,
//                 color: '#10B981',
//                 bgColor: 'rgba(16, 185, 129, 0.08)'
//             },
//             {
//                 label: 'Expenses',
//                 value: formatNumber(totals.expenses || 0),
//                 icon: <Calculator size={18} />,
//                 trend: '-3.2%',
//                 trendIcon: <TrendingDown size={12} />,
//                 color: '#EF4444',
//                 bgColor: 'rgba(239, 68, 68, 0.08)'
//             },
//             {
//                 label: 'Orders',
//                 value: totals.orders || '0',
//                 icon: <ShoppingBag size={18} />,
//                 trend: '+24.7%',
//                 trendIcon: <TrendingUp size={12} />,
//                 color: '#F59E0B',
//                 bgColor: 'rgba(245, 158, 11, 0.08)'
//             },
//             {
//                 label: 'Rating',
//                 value: `${totals.rating?.toFixed(1) || '4.5'}/5`,
//                 icon: <StarIcon size={18} />,
//                 trend: '+0.2',
//                 trendIcon: <Sparkles size={12} />,
//                 color: '#3B82F6',
//                 bgColor: 'rgba(59, 130, 246, 0.08)'
//             }
//         ];

//         return (
//             <div style={{
//                 background: '#FFFFFF',
//                 padding: isMobile ? '16px 12px' : '20px 16px',
//                 marginTop: '-38px'
//                 // borderBottom: '1px solid #E2E8F0'
//             }}>
//                 {/* Title and Welcome */}
//                 <div style={{
//                     marginBottom: '20px'
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '10px',
//                         marginBottom: '6px'
//                     }}>


//                     </div>
//                 </div>

//                 {/* Metrics Grid */}
//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
//                     gap: '12px',
//                     marginBottom: '16px'
//                 }}>
//                     {metrics.map((metric, index) => (
//                         <div
//                             key={index}
//                             onMouseEnter={() => setHoveredMetric(index)}
//                             onMouseLeave={() => setHoveredMetric(null)}
//                             style={{
//                                 background: metric.bgColor,
//                                 borderRadius: '14px',
//                                 padding: '16px',
//                                 border: `1px solid ${metric.color}20`,
//                                 boxShadow: hoveredMetric === index
//                                     ? `0 8px 24px ${metric.color}20`
//                                     : '0 2px 8px rgba(0, 0, 0, 0.04)',
//                                 transform: hoveredMetric === index
//                                     ? 'translateY(-4px)'
//                                     : 'translateY(0)',
//                                 cursor: 'pointer',
//                                 transition: 'all 0.2s ease',
//                                 position: 'relative'
//                             }}
//                         >
//                             {/* Content */}
//                             <div style={{
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 alignItems: 'flex-start',
//                                 marginBottom: '12px'
//                             }}>
//                                 <div style={{
//                                     background: 'white',
//                                     width: '40px',
//                                     height: '40px',
//                                     borderRadius: '10px',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     color: metric.color,
//                                     boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)',
//                                     border: `1px solid ${metric.color}20`
//                                 }}>
//                                     {metric.icon}
//                                 </div>

//                                 <div style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: '3px',
//                                     padding: '4px 8px',
//                                     background: 'rgba(255, 255, 255, 0.9)',
//                                     borderRadius: '12px',
//                                     fontSize: '11px',
//                                     fontWeight: '600',
//                                     color: metric.color,
//                                     border: `1px solid ${metric.color}20`
//                                 }}>
//                                     {metric.trendIcon}
//                                     <span>{metric.trend}</span>
//                                 </div>
//                             </div>

//                             <div style={{
//                                 fontSize: isMobile ? '20px' : '22px',
//                                 fontWeight: '700',
//                                 color: '#1E293B',
//                                 marginBottom: '4px',
//                                 lineHeight: '1'
//                             }}>
//                                 {metric.value}
//                             </div>

//                             <div style={{
//                                 fontSize: '13px',
//                                 fontWeight: '600',
//                                 color: metric.color,
//                                 marginBottom: '6px'
//                             }}>
//                                 {metric.label}
//                             </div>


//                         </div>
//                     ))}
//                 </div>


//             </div>
//         );
//     };

//     // ========== MAIN RENDER ==========

//     if (loading) {
//         return renderLoading();
//     }

//     return (
//         <div ref={mainRef} style={{
//             height: '100vh',
//             display: 'flex',
//             flexDirection: 'column',
//             fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//             background: '#F8FAFC'
//         }}>

//             <div className="row" style={{
//                 flex: 1,
//                 overflowY: 'auto',
//                 scrollbarWidth: 'none',
//                 msOverflowStyle: 'none'
//             }} >
//                 <div className="col-lg-2">   </div>
//                 <div className="col-lg-8">
//                     <p
//                         className="breadcrumb maamaas-home-bredcum"
//                         style={{
//                             position: "fixed",
//                             top: window.innerWidth <= 425 ? " 50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "60px" : "64px",
//                             left: "2vw",
//                             width: "100%",
//                             backgroundColor: "#fff",
//                             zIndex: 1000,
//                             padding: "20px 0",
//                             fontSize: isMobile ? "16px" : "18px",
//                             fontWeight: isMobile ? "normal" : "bold",
//                             textAlign: "center",
//                             margin: 0,
//                         }}
//                     >
//                         {/* <Link
//                                     to="/Newmainlandingpage"
//                                     style={{
//                                         color: "#A055B0",
//                                         fontWeight: "bold",
//                                         textDecoration: "none",
//                                     }}
//                                 >
//                                     Home
//                                 </Link> */}

//                         {/* <span className="separator"> &gt; </span> */}
//                         <Link
//                             to="/foodladingpage"
//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             Food & Beverages

//                         </Link>

//                         <span className="separator"> &gt; </span>
//                         <Link

//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             Dashboard
//                         </Link>
//                     </p>



//                     {/* Left Section */}
//                     {/* <div className="profile-mobilescroll">
//                         <div >

//                             <div className="tab-buttons" style={{ flexWrap: window.innerWidth <= 562 ? "wrap" : "nowrap", marginTop: "40px" }}>
//                                 {Object.keys(tabContent).map((label) => (
//                                     <button
//                                         key={label}
//                                         className={`tab-button ${activeTab === label ? "active" : ""}`}
//                                         onClick={() => setActiveTab(label)}
//                                     >
//                                         {label}
//                                     </button>
//                                 ))}
//                             </div>
//                             <div
//                                 className="tab-content "
//                                 style={{

//                                     height: containerHeight,
//                                     overflowX: "auto",
//                                     overflowY: "scroll",
//                                     // maxWidth: '944px',
//                                 }}
//                             >
//                                 {tabContent[activeTab]}
//                             </div>
//                         </div>
//                     </div> */}
//                     {/* Header Section */}
//                     {renderHeaderSection()}

//                     {/* Offers Section */}
//                     <div style={{
//                         padding: isMobile ? '0 12px 20px' : '0 16px 24px',
//                         background: 'white'
//                     }}>
//                         <FoodOffersSection isMobile={isMobile} />
//                     </div>

//                     {/* Quick Links Section */}
//                     <div style={{
//                         padding: isMobile ? '0 12px 20px' : '0 16px 24px',
//                         background: 'white'
//                     }}>
//                         <FoodQuickLinksSection isMobile={isMobile} onExport={handleExport} />
//                     </div>

//                     {/* Footer Note */}
//                     <div style={{
//                         textAlign: 'center',
//                         padding: '16px',
//                         fontSize: '12px',
//                         color: '#94A3B8',
//                         borderTop: '1px solid #E2E8F0',
//                         margin: isMobile ? '0 12px' : '0 16px',
//                         marginBottom: '20px',
//                         background: '#FFFFFF',
//                         borderRadius: '12px'
//                     }}>
//                         <p style={{ margin: '0 0 6px 0' }}>
//                             Last updated: {new Date().toLocaleTimeString('en-IN', {
//                                 hour: '2-digit',
//                                 minute: '2-digit'
//                             })}
//                         </p>
//                         <div style={{
//                             fontSize: '11px',
//                             color: '#6366F1'
//                         }}>
//                             Dashboard v2.0 • Caterings Pro
//                         </div>
//                     </div>


//                 </div>
//                 <div className="col-lg-2  hideits">
//                     {/* <Foodandbeveragesadvertise /> */}
//                 </div>
//             </div>

//             {/* CSS Styles */}
//             <style>{`
//                 @keyframes spin {
//                     0% { transform: rotate(0deg); }
//                     100% { transform: rotate(360deg); }
//                 }

//                 /* Hide scrollbar for Chrome, Safari and Opera */
//                 ::-webkit-scrollbar {
//                     display: none;
//                 }

//                 /* Smooth transitions */
//                 * {
//                     transition: background-color 0.2s ease,
//                                 transform 0.2s ease,
//                                 box-shadow 0.2s ease;
//                 }

//                 /* Mobile optimizations */
//                 @media (max-width: 768px) {
//                     * {
//                         -webkit-tap-highlight-color: transparent;
//                     }
//                 }
//             `}</style>
//         </div>
//     );
// };

// export default Dashboard;




import React, { useState, useEffect, useRef } from "react";
// import Header from "../common/components/Header";
import { useLocation } from 'react-router-dom';
import Analysis from "../ReportandAnaysisManagment/Food/Analysis";
import Analysisfood from "../ReportandAnaysisManagment/Food/Analysisfood";
import { useNavigate } from 'react-router-dom';
import Dashboard from "./Dashboard";
import { Link } from 'react-router-dom';
import Foodandbeveragesadvertise from './Foodandbeveragesadvertise';
// import "./NavBars"
// import Footer from "../common/components/Footer";
import './Foodandbeverags.css';
const FoodDashboard = () => {


    const [categories, setCategories] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const location = useLocation();
    const isMobile = window.innerWidth <= 768;
    const [activeCategory, setActiveCategory] = useState("Overview");

    useEffect(() => {
        if (location.state?.activeCategory === 'Payments') {
            setActiveCategory('Payments');
        }
    }, [location]);

    useEffect(() => {
        if (location.state?.activeCategory === 'Profile') {
            setActiveCategory('Profile');
        }
    }, [location]);

    useEffect(() => {
        if (location.state?.activeCategory === 'Notifications') {
            setActiveCategory('Notifications');
        }
    }, [location]);
    // Function to handle card click and set the active category
    const handleClick = (category) => {
        setActiveCategory(category);
    };

    const navigate = useNavigate();


    // Automatically activate the first item from backend data
    useEffect(() => {
        if (categories.length > 0) {
            setActiveCategory("Allitems"); // Default to "Allitems"
        }
    }, [categories]);


    const scrollContainerRef = useRef(null);



    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        let interval;

        const startScrolling = () => {
            interval = setInterval(() => {
                if (!isHovered) {
                    scrollContainer.scrollTop += 1; // Scroll down smoothly

                    // Infinite loop logic
                    if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
                        scrollContainer.scrollTop = 0; // Reset to top for seamless loop
                    }
                }
            }, 20); // Adjust speed by changing interval
        };

        startScrolling();

        return () => clearInterval(interval);
    }, [isHovered]);






    return (
        <>
            <div className="container-fluid">

                <div className="row" style={{ marginTop: "40px" }}>

                    {/* Left Column - Scrollable Category List */}
                    <div className="col-lg-2 col-md-12 col-sm-12 col-12">
                        <div
                            style={{
                                maxHeight: "600px",
                                position: "fixed",
                                top: "50px",
                                marginTop: "5px",
                                zIndex: 1000,
                                width: "180px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",

                            }}
                        >

                            <div className="category-container" style={{
                                overflowY: "auto",
                                height: "540px",
                                marginTop: "68px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                            }}>
                                {/* Category Cards */}
                                {[].map(
                                    (category, index) => (
                                        <div
                                            key={index}
                                            className="category-card"
                                            onClick={() => handleClick(category)}
                                            style={{
                                                backgroundColor: activeCategory === category ? "rgb(177 93 198)" : "#D9D9D9",
                                                margin: "8px 0",
                                                padding: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                cursor: "pointer",
                                                justifyContent: "center",
                                                borderRadius: "15px",
                                                transition: "0.3s ease-in-out",
                                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                            }}
                                        >
                                            {/* Icon inside a fixed-size wrapper */}


                                            <div style={{ fontSize: "20px", fontWeight: "bold" }} className="category-card-body d-flex justify-content-center p-0">
                                                {category}
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>

                        </div>
                    </div>

                    {/* Right Column - Content Based on Active Category */}
                    <div className="col-lg-7 col-md-12 col-sm-12 col-12 cartdta-mobileee" style={{ paddingLeft: "0px", paddingRight: "0px" }}  >


                        <p
                            className="breadcrumb maamaas-home-bredcum"
                            style={{
                                position: "fixed",
                                top: isMobile ? "50px" : "64px",
                                left: isMobile ? "5px" : "2vw",
                                width: "100%",
                                backgroundColor: "#fff",
                                zIndex: 1000,
                                padding: "15px 0",
                                fontSize: isMobile ? "14px" : "18px",
                                fontWeight: isMobile ? "normal" : "bold",
                                textAlign: "center",
                                margin: 0,
                            }}
                        >
                            {/* <Link
                                to="/Newmainlandingpage"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Home
                            </Link> */}

                            {/* <span className="separator"> &gt; </span> */}
                            <Link
                                to="/fooddashboard"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Food & Beverages
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link

                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                               Dashboard
                            </Link>
                        </p>



                        <div
                            style={{

                                borderRadius: "8px",
                            }}
                            className="reports-data-analysis"
                        >

                            <Dashboard />


                        </div>
                    </div>
                </div>


                <div className="col-lg-3 col-md-12 col-sm-12 addhide">

                    <Foodandbeveragesadvertise />
                </div>
            </div>
            <style>
                {`
                @media (min-width: 769px) and (max-width:1000px) {
    .reports-data-analysis {
        margin-top: 100px !important;
    }
}
    @media(max-width:991px){
    .addhide{
    display:none;
    }
    }
                `}
            </style>
        </>
    );
};

export default FoodDashboard;

